var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquidbigbanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2495,
    height: 947,
    viewBox: "0 0 2495 947",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2495,
    height: 947,
    fill: "#00abcc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.9805 811.084C-15.9805 811.084 -7.55829 820.624 2.25895 816.657C12.0762 812.691 8.41483 801.228 17.3982 797.598C26.3815 793.969 32.6503 804.378 41.5279 800.791C50.4055 797.205 50.7768 784.112 50.7768 784.112",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9531 974.268C49.9531 974.268 58.3753 983.808 68.1925 979.842C78.0098 975.875 74.3484 964.412 83.3317 960.782C92.3151 957.153 98.5839 967.563 107.462 963.976C116.339 960.389 116.71 947.297 116.71 947.297",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9844 892.676C16.9844 892.676 25.4066 902.216 35.2238 898.249C45.041 894.283 41.3797 882.82 50.363 879.19C59.3463 875.561 65.6151 885.97 74.4928 882.384C83.3704 878.797 83.7416 865.704 83.7416 865.704",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48.9453 729.492C-48.9453 729.492 -40.5231 739.031 -30.7059 735.065C-20.8887 731.099 -24.55 719.635 -15.5667 716.006C-6.58337 712.376 -0.314564 722.786 8.56307 719.199C17.4407 715.612 17.8119 702.52 17.8119 702.52",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-72.0117 74.4346C-72.0117 74.4346 -63.5895 83.9742 -53.7723 80.0078C-43.9551 76.0414 -47.6164 64.5782 -38.6331 60.9487C-29.6498 57.3192 -23.381 67.7289 -14.5033 64.1421C-5.6257 60.5553 -5.25448 47.4629 -5.25448 47.4629",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.711 727.172C191.711 727.172 200.133 736.712 209.95 732.745C219.768 728.779 216.106 717.316 225.09 713.686C234.073 710.057 240.342 720.466 249.219 716.88C258.097 713.293 258.468 700.2 258.468 700.2",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8477 400.803C59.8477 400.803 68.2698 410.343 78.0871 406.377C87.9043 402.41 84.243 390.947 93.2263 387.318C102.21 383.688 108.478 394.098 117.356 390.511C126.234 386.924 126.605 373.832 126.605 373.832",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.08203 237.619C-6.08203 237.619 2.34015 247.159 12.1574 243.192C21.9746 239.226 18.3133 227.763 27.2966 224.133C36.2799 220.504 42.5487 230.913 51.4264 227.327C60.304 223.74 60.6752 210.647 60.6752 210.647",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.641 890.356C257.641 890.356 266.063 899.896 275.88 895.93C285.697 891.963 282.036 880.5 291.019 876.871C300.003 873.241 306.271 883.651 315.149 880.064C324.027 876.477 324.398 863.385 324.398 863.385",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.777 563.988C125.777 563.988 134.2 573.527 144.017 569.561C153.834 565.594 150.173 554.131 159.156 550.502C168.139 546.872 174.408 557.282 183.286 553.695C192.163 550.108 192.535 537.016 192.535 537.016",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39.0469 156.027C-39.0469 156.027 -30.6247 165.566 -20.8075 161.6C-10.9902 157.634 -14.6516 146.17 -5.66825 142.541C3.31507 138.911 9.58388 149.321 18.4615 145.734C27.3391 142.147 27.7104 129.055 27.7104 129.055",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.676 808.764C224.676 808.764 233.098 818.304 242.915 814.337C252.732 810.371 249.071 798.908 258.054 795.278C267.038 791.649 273.307 802.059 282.184 798.472C291.062 794.885 291.433 781.793 291.433 781.793",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8125 482.396C92.8125 482.396 101.235 491.935 111.052 487.969C120.869 484.002 117.208 472.539 126.191 468.91C135.174 465.28 141.443 475.69 150.321 472.103C159.199 468.516 159.57 455.424 159.57 455.424",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8828 319.211C26.8828 319.211 35.305 328.751 45.1222 324.784C54.9395 320.818 51.2781 309.355 60.2614 305.725C69.2448 302.096 75.5136 312.505 84.3912 308.919C93.2688 305.332 93.6401 292.24 93.6401 292.24",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.605 971.949C290.605 971.949 299.028 981.488 308.845 977.522C318.662 973.555 315.001 962.092 323.984 958.463C332.967 954.833 339.236 965.243 348.114 961.656C356.991 958.069 357.363 944.977 357.363 944.977",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.746 645.58C158.746 645.58 167.168 655.119 176.986 651.153C186.803 647.187 183.141 635.723 192.125 632.094C201.108 628.464 207.377 638.874 216.254 635.287C225.132 631.701 225.503 618.608 225.503 618.608",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.621 433.48C918.621 433.48 927.043 443.02 936.861 439.054C946.678 435.087 943.016 423.624 952 419.995C960.983 416.365 967.252 426.775 976.129 423.188C985.007 419.601 985.378 406.509 985.378 406.509",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.762 107.112C786.762 107.112 795.184 116.651 805.001 112.685C814.818 108.719 811.157 97.2555 820.14 93.626C829.124 89.9965 835.392 100.406 844.27 96.8193C853.148 93.2325 853.519 80.1401 853.519 80.1401",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.48 759.849C1050.48 759.849 1058.91 769.389 1068.72 765.422C1078.54 761.456 1074.88 749.993 1083.86 746.363C1092.85 742.734 1099.12 753.144 1107.99 749.557C1116.87 745.97 1117.24 732.878 1117.24 732.878",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.551 596.665C984.551 596.665 992.973 606.205 1002.79 602.238C1012.61 598.272 1008.95 586.809 1017.93 583.179C1026.91 579.55 1033.18 589.959 1042.06 586.372C1050.94 582.786 1051.31 569.693 1051.31 569.693",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.691 270.296C852.691 270.296 861.114 279.836 870.931 275.869C880.748 271.903 877.087 260.44 886.07 256.81C895.053 253.181 901.322 263.59 910.2 260.004C919.077 256.417 919.449 243.324 919.449 243.324",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.41 923.034C1116.41 923.034 1124.84 932.573 1134.65 928.607C1144.47 924.64 1140.81 913.177 1149.79 909.548C1158.78 905.918 1165.04 916.328 1173.92 912.741C1182.8 909.154 1183.17 896.062 1183.17 896.062",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.586 515.073C951.586 515.073 960.008 524.612 969.825 520.646C979.643 516.679 975.981 505.216 984.965 501.587C993.948 497.957 1000.22 508.367 1009.09 504.78C1017.97 501.193 1018.34 488.101 1018.34 488.101",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.727 188.704C819.727 188.704 828.149 198.244 837.966 194.277C847.783 190.311 844.122 178.848 853.105 175.218C862.089 171.589 868.357 181.998 877.235 178.412C886.113 174.825 886.484 161.732 886.484 161.732",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083.45 841.441C1083.45 841.441 1091.87 850.981 1101.69 847.015C1111.51 843.048 1107.84 831.585 1116.83 827.956C1125.81 824.326 1132.08 834.736 1140.96 831.149C1149.84 827.562 1150.21 814.47 1150.21 814.47",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.797 25.5197C753.797 25.5197 762.219 35.0593 772.036 31.0929C781.854 27.1264 778.192 15.6633 787.175 12.0338C796.159 8.40432 802.428 18.814 811.305 15.2272C820.183 11.6404 820.554 -1.45202 820.554 -1.45202",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.52 678.257C1017.52 678.257 1025.94 687.797 1035.76 683.83C1045.58 679.864 1041.91 668.401 1050.9 664.771C1059.88 661.142 1066.15 671.551 1075.03 667.965C1083.91 664.378 1084.28 651.285 1084.28 651.285",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.656 351.888C885.656 351.888 894.078 361.428 903.896 357.462C913.713 353.495 910.052 342.032 919.035 338.402C928.018 334.773 934.287 345.183 943.165 341.596C952.042 338.009 952.413 324.917 952.413 324.917",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3594 780.254C92.3594 780.254 91.791 767.541 101.608 763.575C111.425 759.609 116.755 770.398 125.738 766.768C134.721 763.139 132 751.296 140.877 747.709C149.755 744.123 159.117 753.283 159.117 753.283",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39.5 453.885C-39.5 453.885 -40.0684 441.173 -30.2511 437.206C-20.4339 433.24 -15.1047 444.029 -6.12138 440.4C2.86195 436.77 0.140192 424.927 9.01782 421.341C17.8955 417.754 27.2572 426.914 27.2572 426.914",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.293 943.439C158.293 943.439 157.725 930.726 167.542 926.759C177.359 922.793 182.688 933.582 191.672 929.953C200.655 926.323 197.933 914.48 206.811 910.894C215.688 907.307 225.05 916.467 225.05 916.467",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4297 617.07C26.4297 617.07 25.8613 604.357 35.6785 600.391C45.4958 596.424 50.825 607.213 59.8083 603.584C68.7916 599.954 66.0699 588.112 74.9475 584.525C83.8251 580.938 93.1869 590.098 93.1869 590.098",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.324 861.846C125.324 861.846 124.756 849.134 134.573 845.167C144.39 841.201 149.72 851.99 158.703 848.361C167.686 844.731 164.964 832.888 173.842 829.301C182.72 825.715 192.081 834.875 192.081 834.875",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.53516 535.478C-6.53516 535.478 -7.10354 522.765 2.7137 518.798C12.5309 514.832 17.8601 525.621 26.8435 521.992C35.8268 518.362 33.105 506.52 41.9827 502.933C50.8603 499.346 60.2221 508.506 60.2221 508.506",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3945 698.662C59.3945 698.662 58.8261 685.949 68.6434 681.983C78.4606 678.016 83.7898 688.806 92.7732 685.176C101.756 681.547 99.0347 669.704 107.912 666.117C116.79 662.53 126.152 671.69 126.152 671.69",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.273 486.563C819.273 486.563 818.705 473.85 828.522 469.883C838.34 465.917 843.669 476.706 852.652 473.077C861.635 469.447 858.914 457.605 867.791 454.018C876.669 450.431 886.031 459.591 886.031 459.591",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.41 160.194C687.41 160.194 686.842 147.481 696.659 143.515C706.476 139.548 711.805 150.338 720.789 146.708C729.772 143.079 727.05 131.236 735.928 127.649C744.806 124.062 754.167 133.222 754.167 133.222",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.133 812.931C951.133 812.931 950.564 800.219 960.382 796.252C970.199 792.286 975.528 803.075 984.511 799.445C993.495 795.816 990.773 783.973 999.651 780.386C1008.53 776.8 1017.89 785.96 1017.89 785.96",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.48 -2.99048C621.48 -2.99048 620.912 -15.7033 630.729 -19.6697C640.547 -23.6361 645.876 -12.8468 654.859 -16.4763C663.842 -20.1058 661.121 -31.9486 669.998 -35.5354C678.876 -39.1222 688.238 -29.9622 688.238 -29.9622",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.203 649.747C885.203 649.747 884.635 637.034 894.452 633.068C904.269 629.101 909.598 639.891 918.582 636.261C927.565 632.632 924.843 620.789 933.721 617.202C942.599 613.615 951.96 622.775 951.96 622.775",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.344 323.378C753.344 323.378 752.775 310.666 762.593 306.699C772.41 302.733 777.739 313.522 786.722 309.892C795.706 306.263 792.984 294.42 801.862 290.833C810.739 287.247 820.101 296.407 820.101 296.407",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.07 976.116C1017.07 976.116 1016.5 963.403 1026.32 959.437C1036.13 955.47 1041.46 966.259 1050.45 962.63C1059.43 959 1056.71 947.158 1065.58 943.571C1074.46 939.984 1083.82 949.144 1083.82 949.144",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.238 568.155C852.238 568.155 851.67 555.442 861.487 551.476C871.304 547.509 876.634 558.298 885.617 554.669C894.6 551.039 891.878 539.197 900.756 535.61C909.634 532.023 918.996 541.183 918.996 541.183",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.375 241.786C720.375 241.786 719.807 229.073 729.624 225.107C739.441 221.141 744.77 231.93 753.754 228.3C762.737 224.671 760.015 212.828 768.893 209.241C777.77 205.654 787.132 214.814 787.132 214.814",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.098 894.524C984.098 894.524 983.529 881.811 993.347 877.844C1003.16 873.878 1008.49 884.667 1017.48 881.038C1026.46 877.408 1023.74 865.565 1032.62 861.979C1041.49 858.392 1050.85 867.552 1050.85 867.552",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.445 78.6017C654.445 78.6017 653.877 65.8889 663.694 61.9225C673.511 57.9561 678.841 68.7453 687.824 65.1158C696.807 61.4863 694.086 49.6436 702.963 46.0568C711.841 42.47 721.203 51.63 721.203 51.63",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.168 731.339C918.168 731.339 917.6 718.626 927.417 714.66C937.234 710.694 942.563 721.483 951.547 717.853C960.53 714.224 957.808 702.381 966.686 698.794C975.563 695.207 984.925 704.367 984.925 704.367",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.309 404.97C786.309 404.97 785.74 392.258 795.557 388.291C805.375 384.325 810.704 395.114 819.687 391.485C828.671 387.855 825.949 376.012 834.826 372.426C843.704 368.839 853.066 377.999 853.066 377.999",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3281 43.6049C36.3281 43.6049 35.7597 30.8921 45.577 26.9257C55.3942 22.9592 60.7234 33.7485 69.7067 30.119C78.6901 26.4895 75.9683 14.6468 84.8459 11.06C93.7236 7.47317 103.085 16.6332 103.085 16.6332",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.051 696.342C300.051 696.342 299.482 683.63 309.3 679.663C319.117 675.697 324.446 686.486 333.429 682.857C342.413 679.227 339.691 667.384 348.569 663.797C357.446 660.211 366.808 669.371 366.808 669.371",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.188 369.974C168.188 369.974 167.619 357.261 177.436 353.294C187.254 349.328 192.583 360.117 201.566 356.488C210.549 352.858 207.828 341.016 216.705 337.429C225.583 333.842 234.945 343.002 234.945 343.002",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.258 206.789C102.258 206.789 101.689 194.076 111.507 190.11C121.324 186.144 126.653 196.933 135.636 193.303C144.62 189.674 141.898 177.831 150.776 174.244C159.653 170.657 169.015 179.818 169.015 179.818",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.98 859.527C365.98 859.527 365.412 846.814 375.229 842.847C385.047 838.881 390.376 849.67 399.359 846.041C408.342 842.411 405.621 830.569 414.498 826.982C423.376 823.395 432.738 832.555 432.738 832.555",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.117 533.158C234.117 533.158 233.549 520.445 243.366 516.479C253.183 512.512 258.512 523.302 267.496 519.672C276.479 516.043 273.757 504.2 282.635 500.613C291.513 497.026 300.874 506.186 300.874 506.186",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.293 125.197C69.293 125.197 68.7246 112.484 78.5418 108.518C88.3591 104.551 93.6883 115.341 102.672 111.711C111.655 108.082 108.933 96.2389 117.811 92.6521C126.688 89.0653 136.05 98.2253 136.05 98.2253",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.016 777.935C333.016 777.935 332.447 765.222 342.264 761.255C352.082 757.289 357.411 768.078 366.394 764.449C375.378 760.819 372.656 748.976 381.533 745.39C390.411 741.803 399.773 750.963 399.773 750.963",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.152 451.566C201.152 451.566 200.584 438.853 210.401 434.887C220.218 430.92 225.548 441.709 234.531 438.08C243.514 434.45 240.793 422.608 249.67 419.021C258.548 415.434 267.91 424.594 267.91 424.594",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.223 288.381C135.223 288.381 134.654 275.669 144.472 271.702C154.289 267.736 159.618 278.525 168.601 274.896C177.585 271.266 174.863 259.423 183.74 255.837C192.618 252.25 201.98 261.41 201.98 261.41",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.945 941.119C398.945 941.119 398.377 928.406 408.194 924.44C418.011 920.473 423.341 931.262 432.324 927.633C441.307 924.003 438.586 912.161 447.463 908.574C456.341 904.987 465.703 914.147 465.703 914.147",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.086 614.75C267.086 614.75 266.518 602.037 276.335 598.071C286.152 594.105 291.481 604.894 300.465 601.264C309.448 597.635 306.726 585.792 315.604 582.205C324.481 578.618 333.843 587.778 333.843 587.778",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.96 402.651C1026.96 402.651 1026.39 389.938 1036.21 385.972C1046.03 382.005 1051.36 392.794 1060.34 389.165C1069.32 385.535 1066.6 373.693 1075.48 370.106C1084.36 366.519 1093.72 375.679 1093.72 375.679",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.102 76.2821C895.102 76.2821 894.533 63.5693 904.35 59.6029C914.168 55.6365 919.497 66.4258 928.48 62.7963C937.464 59.1668 934.742 47.324 943.619 43.7372C952.497 40.1504 961.859 49.3104 961.859 49.3104",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.82 729.019C1158.82 729.019 1158.26 716.307 1168.07 712.34C1177.89 708.374 1183.22 719.163 1192.2 715.534C1201.19 711.904 1198.46 700.061 1207.34 696.475C1216.22 692.888 1225.58 702.048 1225.58 702.048",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.031 239.466C961.031 239.466 960.463 226.754 970.28 222.787C980.097 218.821 985.427 229.61 994.41 225.981C1003.39 222.351 1000.67 210.508 1009.55 206.922C1018.43 203.335 1027.79 212.495 1027.79 212.495",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.75 892.204C1224.75 892.204 1224.19 879.491 1234 875.525C1243.82 871.558 1249.15 882.348 1258.13 878.718C1267.12 875.089 1264.39 863.246 1273.27 859.659C1282.15 856.072 1291.51 865.232 1291.51 865.232",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.93 484.243C1059.93 484.243 1059.36 471.53 1069.17 467.564C1078.99 463.597 1084.32 474.387 1093.3 470.757C1102.29 467.128 1099.57 455.285 1108.44 451.698C1117.32 448.111 1126.68 457.271 1126.68 457.271",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.066 157.874C928.066 157.874 927.498 145.161 937.315 141.195C947.133 137.229 952.462 148.018 961.445 144.388C970.428 140.759 967.707 128.916 976.584 125.329C985.462 121.743 994.824 130.903 994.824 130.903",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.79 810.612C1191.79 810.612 1191.22 797.899 1201.04 793.932C1210.86 789.966 1216.18 800.755 1225.17 797.126C1234.15 793.496 1231.43 781.654 1240.31 778.067C1249.18 774.48 1258.55 783.64 1258.55 783.64",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.86 647.427C1125.86 647.427 1125.29 634.714 1135.11 630.748C1144.93 626.782 1150.25 637.571 1159.24 633.941C1168.22 630.312 1165.5 618.469 1174.38 614.882C1183.25 611.296 1192.62 620.456 1192.62 620.456",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.996 321.059C993.996 321.059 993.428 308.346 1003.24 304.379C1013.06 300.413 1018.39 311.202 1027.37 307.573C1036.36 303.943 1033.64 292.1 1042.51 288.514C1051.39 284.927 1060.75 294.087 1060.75 294.087",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1257.72 973.796C1257.72 973.796 1257.15 961.083 1266.97 957.117C1276.78 953.15 1282.11 963.94 1291.1 960.31C1300.08 956.681 1297.36 944.838 1306.24 941.251C1315.11 937.664 1324.48 946.824 1324.48 946.824",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.676 -9.47729C135.676 -9.47729 144.098 0.0623418 153.915 -3.90408C163.732 -7.87051 160.071 -19.3336 169.054 -22.9631C178.038 -26.5926 184.307 -16.183 193.184 -19.7698C202.062 -23.3566 202.433 -36.449 202.433 -36.449",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.398 643.26C399.398 643.26 407.821 652.8 417.638 648.833C427.455 644.867 423.794 633.404 432.777 629.774C441.76 626.145 448.029 636.554 456.907 632.968C465.784 629.381 466.156 616.288 466.156 616.288",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.539 316.891C267.539 316.891 275.961 326.431 285.778 322.465C295.596 318.498 291.934 307.035 300.918 303.406C309.901 299.776 316.17 310.186 325.047 306.599C333.925 303.012 334.296 289.92 334.296 289.92",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.262 969.629C531.262 969.629 539.684 979.169 549.501 975.202C559.318 971.236 555.657 959.773 564.64 956.143C573.624 952.514 579.892 962.923 588.77 959.336C597.648 955.75 598.019 942.657 598.019 942.657",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.605 153.707C201.605 153.707 210.028 163.247 219.845 159.28C229.662 155.314 226.001 143.851 234.984 140.221C243.967 136.592 250.236 147.001 259.114 143.415C267.991 139.828 268.363 126.735 268.363 126.735",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.328 806.445C465.328 806.445 473.75 815.984 483.568 812.018C493.385 808.051 489.723 796.588 498.707 792.959C507.69 789.329 513.959 799.739 522.837 796.152C531.714 792.565 532.085 779.473 532.085 779.473",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.469 480.076C333.469 480.076 341.891 489.615 351.708 485.649C361.525 481.683 357.864 470.219 366.847 466.59C375.831 462.96 382.099 473.37 390.977 469.783C399.855 466.197 400.226 453.104 400.226 453.104",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.641 72.1149C168.641 72.1149 177.063 81.6545 186.88 77.6881C196.697 73.7217 193.036 62.2585 202.019 58.629C211.003 54.9995 217.271 65.4092 226.149 61.8224C235.027 58.2356 235.398 45.1432 235.398 45.1432",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.363 724.852C432.363 724.852 440.785 734.392 450.603 730.426C460.42 726.459 456.759 714.996 465.742 711.367C474.725 707.737 480.994 718.147 489.872 714.56C498.749 710.973 499.121 697.881 499.121 697.881",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.504 398.484C300.504 398.484 308.926 408.023 318.743 404.057C328.561 400.09 324.899 388.627 333.883 384.998C342.866 381.368 349.135 391.778 358.012 388.191C366.89 384.604 367.261 371.512 367.261 371.512",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.57 235.299C234.57 235.299 242.992 244.839 252.81 240.873C262.627 236.906 258.966 225.443 267.949 221.813C276.932 218.184 283.201 228.594 292.079 225.007C300.956 221.42 301.328 208.328 301.328 208.328",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.297 888.037C498.297 888.037 506.719 897.576 516.536 893.61C526.354 889.644 522.692 878.18 531.675 874.551C540.659 870.921 546.928 881.331 555.805 877.744C564.683 874.157 565.054 861.065 565.054 861.065",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.434 561.668C366.434 561.668 374.856 571.208 384.673 567.241C394.49 563.275 390.829 551.812 399.812 548.182C408.796 544.553 415.064 554.962 423.942 551.375C432.82 547.789 433.191 534.696 433.191 534.696",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.31 349.569C1126.31 349.569 1134.73 359.108 1144.55 355.142C1154.37 351.175 1150.71 339.712 1159.69 336.083C1168.67 332.453 1174.94 342.863 1183.82 339.276C1192.7 335.689 1193.07 322.597 1193.07 322.597",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.449 23.2C994.449 23.2 1002.87 32.7396 1012.69 28.7732C1022.51 24.8067 1018.84 13.3436 1027.83 9.71411C1036.81 6.08461 1043.08 16.4943 1051.96 12.9075C1060.84 9.32068 1061.21 -3.77173 1061.21 -3.77173",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.17 675.937C1258.17 675.937 1266.59 685.477 1276.41 681.511C1286.23 677.544 1282.57 666.081 1291.55 662.451C1300.53 658.822 1306.8 669.232 1315.68 665.645C1324.56 662.058 1324.93 648.966 1324.93 648.966",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.38 186.384C1060.38 186.384 1068.8 195.924 1078.62 191.957C1088.44 187.991 1084.77 176.528 1093.76 172.898C1102.74 169.269 1109.01 179.679 1117.89 176.092C1126.76 172.505 1127.14 159.413 1127.14 159.413",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.1 839.122C1324.1 839.122 1332.52 848.661 1342.34 844.695C1352.16 840.728 1348.5 829.265 1357.48 825.636C1366.46 822.006 1372.73 832.416 1381.61 828.829C1390.49 825.242 1390.86 812.15 1390.86 812.15",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.41 104.792C1027.41 104.792 1035.84 114.332 1045.65 110.365C1055.47 106.399 1051.81 94.9358 1060.79 91.3063C1069.78 87.6768 1076.04 98.0864 1084.92 94.4996C1093.8 90.9128 1094.17 77.8204 1094.17 77.8204",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1291.14 757.53C1291.14 757.53 1299.56 767.069 1309.38 763.103C1319.19 759.136 1315.53 747.673 1324.52 744.044C1333.5 740.414 1339.77 750.824 1348.65 747.237C1357.52 743.65 1357.89 730.558 1357.89 730.558",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.35 267.976C1093.35 267.976 1101.77 277.516 1111.59 273.55C1121.4 269.583 1117.74 258.12 1126.73 254.491C1135.71 250.861 1141.98 261.271 1150.86 257.684C1159.73 254.097 1160.1 241.005 1160.1 241.005",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.07 920.714C1357.07 920.714 1365.49 930.254 1375.31 926.287C1385.13 922.321 1381.47 910.858 1390.45 907.228C1399.43 903.599 1405.7 914.008 1414.58 910.421C1423.46 906.835 1423.83 893.742 1423.83 893.742",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.09 559.348C607.09 559.348 615.512 568.888 625.329 564.921C635.147 560.955 631.485 549.492 640.468 545.862C649.452 542.233 655.721 552.643 664.598 549.056C673.476 545.469 673.847 532.377 673.847 532.377",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.227 232.98C475.227 232.98 483.649 242.519 493.466 238.553C503.283 234.586 499.622 223.123 508.605 219.494C517.589 215.864 523.857 226.274 532.735 222.687C541.613 219.1 541.984 206.008 541.984 206.008",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.949 885.717C738.949 885.717 747.371 895.257 757.189 891.29C767.006 887.324 763.345 875.861 772.328 872.231C781.311 868.602 787.58 879.011 796.458 875.425C805.335 871.838 805.706 858.745 805.706 858.745",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.297 69.7952C409.297 69.7952 417.719 79.3348 427.536 75.3684C437.354 71.402 433.692 59.9388 442.675 56.3093C451.659 52.6798 457.928 63.0895 466.805 59.5027C475.683 55.9159 476.054 42.8235 476.054 42.8235",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.02 722.533C673.02 722.533 681.442 732.072 691.259 728.106C701.076 724.139 697.415 712.676 706.398 709.047C715.381 705.417 721.65 715.827 730.528 712.24C739.406 708.653 739.777 695.561 739.777 695.561",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.156 396.164C541.156 396.164 549.578 405.704 559.396 401.737C569.213 397.771 565.552 386.308 574.535 382.678C583.518 379.049 589.787 389.458 598.665 385.871C607.542 382.285 607.913 369.192 607.913 369.192",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.332 -11.797C376.332 -11.797 384.754 -2.25736 394.571 -6.22378C404.389 -10.1902 400.727 -21.6533 409.711 -25.2828C418.694 -28.9123 424.963 -18.5027 433.84 -22.0895C442.718 -25.6763 443.089 -38.7687 443.089 -38.7687",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.055 640.94C640.055 640.94 648.477 650.48 658.294 646.514C668.111 642.547 664.45 631.084 673.433 627.455C682.417 623.825 688.685 634.235 697.563 630.648C706.441 627.061 706.812 613.969 706.812 613.969",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.191 314.572C508.191 314.572 516.614 324.111 526.431 320.145C536.248 316.179 532.587 304.715 541.57 301.086C550.553 297.456 556.822 307.866 565.7 304.279C574.577 300.693 574.949 287.6 574.949 287.6",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.914 967.309C771.914 967.309 780.336 976.849 790.153 972.882C799.971 968.916 796.309 957.453 805.293 953.823C814.276 950.194 820.545 960.604 829.422 957.017C838.3 953.43 838.671 940.338 838.671 940.338",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.262 151.387C442.262 151.387 450.684 160.927 460.501 156.961C470.318 152.994 466.657 141.531 475.64 137.902C484.624 134.272 490.892 144.682 499.77 141.095C508.648 137.508 509.019 124.416 509.019 124.416",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.984 804.125C705.984 804.125 714.407 813.665 724.224 809.698C734.041 805.732 730.38 794.269 739.363 790.639C748.346 787.01 754.615 797.419 763.493 793.832C772.37 790.246 772.742 777.153 772.742 777.153",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.121 477.756C574.121 477.756 582.543 487.296 592.361 483.329C602.178 479.363 598.516 467.9 607.5 464.27C616.483 460.641 622.752 471.05 631.629 467.464C640.507 463.877 640.878 450.784 640.878 450.784",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334 265.657C1334 265.657 1342.42 275.196 1352.24 271.23C1362.06 267.264 1358.4 255.8 1367.38 252.171C1376.36 248.541 1382.63 258.951 1391.51 255.364C1400.39 251.777 1400.76 238.685 1400.76 238.685",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465.86 592.026C1465.86 592.026 1474.29 601.565 1484.1 597.599C1493.92 593.632 1490.26 582.169 1499.24 578.54C1508.23 574.91 1514.49 585.32 1523.37 581.733C1532.25 578.146 1532.62 565.054 1532.62 565.054",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.93 428.841C1399.93 428.841 1408.35 438.381 1418.17 434.414C1427.99 430.448 1424.32 418.985 1433.31 415.355C1442.29 411.726 1448.56 422.135 1457.44 418.549C1466.32 414.962 1466.69 401.869 1466.69 401.869",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1597.72 918.394C1597.72 918.394 1606.14 927.934 1615.96 923.967C1625.78 920.001 1622.12 908.538 1631.1 904.908C1640.08 901.279 1646.35 911.688 1655.23 908.102C1664.11 904.515 1664.48 891.422 1664.48 891.422",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.07 102.472C1268.07 102.472 1276.49 112.012 1286.31 108.046C1296.13 104.079 1292.47 92.6161 1301.45 88.9866C1310.43 85.3571 1316.7 95.7667 1325.58 92.1799C1334.46 88.5931 1334.83 75.5007 1334.83 75.5007",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.79 755.21C1531.79 755.21 1540.22 764.749 1550.03 760.783C1559.85 756.817 1556.19 745.353 1565.17 741.724C1574.15 738.095 1580.42 748.504 1589.3 744.917C1598.18 741.331 1598.55 728.238 1598.55 728.238",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366.96 347.249C1366.96 347.249 1375.39 356.789 1385.2 352.822C1395.02 348.856 1391.36 337.393 1400.34 333.763C1409.33 330.134 1415.6 340.543 1424.47 336.956C1433.35 333.37 1433.72 320.277 1433.72 320.277",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.11 20.8802C1235.11 20.8802 1243.53 30.4199 1253.34 26.4535C1263.16 22.487 1259.5 11.0239 1268.48 7.39441C1277.47 3.76491 1283.74 14.1746 1292.61 10.5878C1301.49 7.00097 1301.86 -6.09143 1301.86 -6.09143",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.83 673.618C1498.83 673.618 1507.25 683.157 1517.07 679.191C1526.88 675.224 1523.22 663.761 1532.21 660.132C1541.19 656.502 1547.46 666.912 1556.34 663.325C1565.21 659.738 1565.59 646.646 1565.59 646.646",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1432.89 510.433C1432.89 510.433 1441.32 519.973 1451.13 516.007C1460.95 512.04 1457.29 500.577 1466.27 496.948C1475.26 493.318 1481.53 503.728 1490.4 500.141C1499.28 496.554 1499.65 483.462 1499.65 483.462",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301.04 184.065C1301.04 184.065 1309.46 193.604 1319.27 189.638C1329.09 185.671 1325.43 174.208 1334.41 170.579C1343.4 166.949 1349.67 177.359 1358.54 173.772C1367.42 170.185 1367.79 157.093 1367.79 157.093",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1564.76 836.802C1564.76 836.802 1573.18 846.342 1583 842.375C1592.81 838.409 1589.15 826.946 1598.14 823.316C1607.12 819.687 1613.39 830.096 1622.27 826.51C1631.14 822.923 1631.52 809.83 1631.52 809.83",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.738 612.43C507.738 612.43 507.17 599.718 516.987 595.751C526.804 591.785 532.134 602.574 541.117 598.945C550.1 595.315 547.378 583.472 556.256 579.886C565.134 576.299 574.496 585.459 574.496 585.459",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.879 286.062C375.879 286.062 375.311 273.349 385.128 269.383C394.945 265.416 400.274 276.205 409.258 272.576C418.241 268.946 415.519 257.104 424.397 253.517C433.274 249.93 442.636 259.09 442.636 259.09",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.602 938.799C639.602 938.799 639.033 926.086 648.85 922.12C658.668 918.154 663.997 928.943 672.98 925.313C681.964 921.684 679.242 909.841 688.119 906.254C696.997 902.668 706.359 911.828 706.359 911.828",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.945 122.877C309.945 122.877 309.377 110.165 319.194 106.198C329.011 102.232 334.341 113.021 343.324 109.391C352.307 105.762 349.586 93.9192 358.463 90.3324C367.341 86.7456 376.703 95.9056 376.703 95.9056",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.668 775.615C573.668 775.615 573.1 762.902 582.917 758.936C592.734 754.969 598.063 765.758 607.047 762.129C616.03 758.499 613.308 746.657 622.186 743.07C631.063 739.483 640.425 748.643 640.425 748.643",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.809 449.246C441.809 449.246 441.24 436.533 451.057 432.567C460.875 428.6 466.204 439.39 475.187 435.76C484.171 432.131 481.449 420.288 490.326 416.701C499.204 413.114 508.566 422.274 508.566 422.274",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.98 41.2852C276.98 41.2852 276.412 28.5724 286.229 24.606C296.047 20.6395 301.376 31.4288 310.359 27.7993C319.342 24.1698 316.621 12.3271 325.498 8.74026C334.376 5.15347 343.738 14.3135 343.738 14.3135",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.703 694.023C540.703 694.023 540.135 681.31 549.952 677.343C559.769 673.377 565.098 684.166 574.082 680.537C583.065 676.907 580.343 665.065 589.221 661.478C598.099 657.891 607.46 667.051 607.46 667.051",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.844 367.654C408.844 367.654 408.275 354.941 418.093 350.975C427.91 347.008 433.239 357.798 442.222 354.168C451.206 350.539 448.484 338.696 457.362 335.109C466.239 331.522 475.601 340.682 475.601 340.682",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.91 204.47C342.91 204.47 342.342 191.757 352.159 187.79C361.976 183.824 367.305 194.613 376.289 190.984C385.272 187.354 382.55 175.512 391.428 171.925C400.306 168.338 409.667 177.498 409.667 177.498",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.637 857.207C606.637 857.207 606.068 844.494 615.886 840.528C625.703 836.561 631.032 847.351 640.015 843.721C648.999 840.092 646.277 828.249 655.155 824.662C664.032 821.075 673.394 830.235 673.394 830.235",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.773 530.838C474.773 530.838 474.205 518.125 484.022 514.159C493.84 510.193 499.169 520.982 508.152 517.352C517.135 513.723 514.414 501.88 523.291 498.293C532.169 494.707 541.531 503.867 541.531 503.867",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.65 318.739C1234.65 318.739 1234.08 306.026 1243.9 302.06C1253.72 298.093 1259.05 308.883 1268.03 305.253C1277.01 301.624 1274.29 289.781 1283.17 286.194C1292.05 282.607 1301.41 291.767 1301.41 291.767",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366.51 645.108C1366.51 645.108 1365.94 632.395 1375.76 628.428C1385.58 624.462 1390.91 635.251 1399.89 631.622C1408.87 627.992 1406.15 616.15 1415.03 612.563C1423.91 608.976 1433.27 618.136 1433.27 618.136",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.38 971.476C1498.38 971.476 1497.81 958.764 1507.62 954.797C1517.44 950.831 1522.77 961.62 1531.75 957.99C1540.74 954.361 1538.02 942.518 1546.89 938.931C1555.77 935.345 1565.13 944.505 1565.13 944.505",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.72 155.555C1168.72 155.555 1168.15 142.842 1177.97 138.875C1187.78 134.909 1193.11 145.698 1202.1 142.069C1211.08 138.439 1208.36 126.596 1217.24 123.01C1226.11 119.423 1235.48 128.583 1235.48 128.583",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1432.44 808.292C1432.44 808.292 1431.87 795.579 1441.69 791.613C1451.51 787.646 1456.84 798.436 1465.82 794.806C1474.8 791.177 1472.08 779.334 1480.96 775.747C1489.84 772.16 1499.2 781.32 1499.2 781.32",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.75 73.9624C1135.75 73.9624 1135.19 61.2496 1145 57.2832C1154.82 53.3168 1160.15 64.1061 1169.13 60.4766C1178.12 56.8471 1175.39 45.0043 1184.27 41.4175C1193.15 37.8307 1202.51 46.9907 1202.51 46.9907",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.48 726.7C1399.48 726.7 1398.91 713.987 1408.73 710.021C1418.54 706.054 1423.87 716.843 1432.86 713.214C1441.84 709.584 1439.12 697.742 1447.99 694.155C1456.87 690.568 1466.23 699.728 1466.23 699.728",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.69 237.147C1201.69 237.147 1201.12 224.434 1210.94 220.468C1220.75 216.501 1226.08 227.29 1235.07 223.661C1244.05 220.031 1241.33 208.189 1250.21 204.602C1259.08 201.015 1268.44 210.175 1268.44 210.175",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465.41 889.884C1465.41 889.884 1464.84 877.171 1474.66 873.205C1484.48 869.239 1489.81 880.028 1498.79 876.398C1507.77 872.769 1505.05 860.926 1513.93 857.339C1522.81 853.752 1532.17 862.912 1532.17 862.912",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.43 528.519C715.43 528.519 714.861 515.806 724.679 511.839C734.496 507.873 739.825 518.662 748.808 515.033C757.792 511.403 755.07 499.56 763.948 495.974C772.825 492.387 782.187 501.547 782.187 501.547",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.566 202.15C583.566 202.15 582.998 189.437 592.815 185.471C602.633 181.504 607.962 192.294 616.945 188.664C625.928 185.035 623.207 173.192 632.084 169.605C640.962 166.018 650.324 175.178 650.324 175.178",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.289 854.887C847.289 854.887 846.721 842.174 856.538 838.208C866.355 834.242 871.684 845.031 880.668 841.401C889.651 837.772 886.929 825.929 895.807 822.342C904.685 818.756 914.046 827.916 914.046 827.916",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.637 38.9655C517.637 38.9655 517.068 26.2527 526.886 22.2863C536.703 18.3198 542.032 29.1091 551.015 25.4796C559.999 21.8501 557.277 10.0074 566.155 6.42056C575.032 2.83377 584.394 11.9938 584.394 11.9938",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.359 691.703C781.359 691.703 780.791 678.99 790.608 675.024C800.425 671.057 805.755 681.847 814.738 678.217C823.721 674.588 821 662.745 829.877 659.158C838.755 655.571 848.117 664.731 848.117 664.731",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.496 365.334C649.496 365.334 648.928 352.621 658.745 348.655C668.562 344.689 673.891 355.478 682.875 351.848C691.858 348.219 689.136 336.376 698.014 332.789C706.892 329.203 716.253 338.363 716.253 338.363",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.395 610.111C748.395 610.111 747.826 597.398 757.643 593.432C767.461 589.465 772.79 600.254 781.773 596.625C790.756 592.995 788.035 581.153 796.912 577.566C805.79 573.979 815.152 583.139 815.152 583.139",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.531 283.742C616.531 283.742 615.963 271.029 625.78 267.063C635.597 263.096 640.927 273.886 649.91 270.256C658.893 266.627 656.171 254.784 665.049 251.197C673.927 247.61 683.288 256.77 683.288 256.77",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.254 936.479C880.254 936.479 879.686 923.767 889.503 919.8C899.32 915.834 904.649 926.623 913.633 922.994C922.616 919.364 919.894 907.521 928.772 903.935C937.649 900.348 947.011 909.508 947.011 909.508",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.602 120.558C550.602 120.558 550.033 107.845 559.85 103.878C569.668 99.912 574.997 110.701 583.98 107.072C592.964 103.442 590.242 91.5995 599.119 88.0127C607.997 84.4259 617.359 93.5859 617.359 93.5859",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.324 773.295C814.324 773.295 813.756 760.582 823.573 756.616C833.39 752.649 838.72 763.439 847.703 759.809C856.686 756.18 853.964 744.337 862.842 740.75C871.72 737.163 881.081 746.323 881.081 746.323",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.461 446.926C682.461 446.926 681.893 434.214 691.71 430.247C701.527 426.281 706.856 437.07 715.84 433.441C724.823 429.811 722.101 417.968 730.979 414.382C739.856 410.795 749.218 419.955 749.218 419.955",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.34 234.827C1442.34 234.827 1441.77 222.114 1451.59 218.148C1461.41 214.181 1466.74 224.971 1475.72 221.341C1484.7 217.712 1481.98 205.869 1490.86 202.282C1499.74 198.695 1509.1 207.855 1509.1 207.855",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.2 561.196C1574.2 561.196 1573.63 548.483 1583.45 544.516C1593.27 540.55 1598.6 551.339 1607.58 547.71C1616.57 544.08 1613.84 532.238 1622.72 528.651C1631.6 525.064 1640.96 534.224 1640.96 534.224",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.27 398.011C1508.27 398.011 1507.7 385.299 1517.52 381.332C1527.34 377.366 1532.66 388.155 1541.65 384.526C1550.63 380.896 1547.91 369.053 1556.79 365.466C1565.66 361.88 1575.03 371.04 1575.03 371.04",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1706.06 887.564C1706.06 887.564 1705.49 874.852 1715.31 870.885C1725.13 866.919 1730.46 877.708 1739.44 874.079C1748.42 870.449 1745.7 858.606 1754.58 855.02C1763.46 851.433 1772.82 860.593 1772.82 860.593",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.41 71.6427C1376.41 71.6427 1375.84 58.9299 1385.66 54.9635C1395.48 50.9971 1400.81 61.7864 1409.79 58.1569C1418.77 54.5274 1416.05 42.6846 1424.93 39.0978C1433.81 35.511 1443.17 44.671 1443.17 44.671",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640.13 724.38C1640.13 724.38 1639.56 711.667 1649.38 707.701C1659.2 703.735 1664.53 714.524 1673.51 710.894C1682.49 707.265 1679.77 695.422 1688.65 691.835C1697.53 688.248 1706.89 697.408 1706.89 697.408",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475.3 316.419C1475.3 316.419 1474.74 303.706 1484.55 299.74C1494.37 295.774 1499.7 306.563 1508.68 302.933C1517.67 299.304 1514.94 287.461 1523.82 283.874C1532.7 280.288 1542.06 289.448 1542.06 289.448",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1607.17 642.788C1607.17 642.788 1606.6 630.075 1616.42 626.109C1626.23 622.142 1631.56 632.932 1640.55 629.302C1649.53 625.673 1646.81 613.83 1655.69 610.243C1664.56 606.656 1673.93 615.816 1673.93 615.816",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.23 479.604C1541.23 479.604 1540.67 466.891 1550.48 462.924C1560.3 458.958 1565.63 469.747 1574.61 466.118C1583.6 462.488 1580.87 450.645 1589.75 447.059C1598.63 443.472 1607.99 452.632 1607.99 452.632",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1739.03 969.157C1739.03 969.157 1738.46 956.444 1748.28 952.477C1758.09 948.511 1763.42 959.3 1772.41 955.671C1781.39 952.041 1778.67 940.199 1787.55 936.612C1796.42 933.025 1805.78 942.185 1805.78 942.185",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.38 153.235C1409.38 153.235 1408.81 140.522 1418.62 136.556C1428.44 132.589 1433.77 143.379 1442.75 139.749C1451.74 136.12 1449.02 124.277 1457.89 120.69C1466.77 117.103 1476.13 126.263 1476.13 126.263",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1673.1 805.972C1673.1 805.972 1672.53 793.26 1682.35 789.293C1692.16 785.327 1697.49 796.116 1706.48 792.486C1715.46 788.857 1712.74 777.014 1721.62 773.427C1730.49 769.841 1739.85 779.001 1739.85 779.001",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.54 139.789C1645.54 139.789 1653.96 149.329 1663.77 145.362C1673.59 141.396 1669.93 129.933 1678.91 126.303C1687.9 122.674 1694.17 133.083 1703.04 129.496C1711.92 125.91 1712.29 112.817 1712.29 112.817",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.39 466.158C1777.39 466.158 1785.82 475.697 1795.63 471.731C1805.45 467.765 1801.79 456.301 1810.77 452.672C1819.76 449.042 1826.03 459.452 1834.9 455.865C1843.78 452.278 1844.15 439.186 1844.15 439.186",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1975.19 955.711C1975.19 955.711 1983.61 965.25 1993.43 961.284C2003.24 957.318 1999.58 945.854 2008.57 942.225C2017.55 938.595 2023.82 949.005 2032.7 945.418C2041.57 941.831 2041.94 928.739 2041.94 928.739",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1711.46 302.973C1711.46 302.973 1719.89 312.513 1729.7 308.546C1739.52 304.58 1735.86 293.117 1744.84 289.487C1753.83 285.858 1760.1 296.268 1768.97 292.681C1777.85 289.094 1778.22 276.002 1778.22 276.002",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.26 792.526C1909.26 792.526 1917.68 802.066 1927.5 798.1C1937.31 794.133 1933.65 782.67 1942.64 779.041C1951.62 775.411 1957.89 785.821 1966.77 782.234C1975.64 778.647 1976.02 765.555 1976.02 765.555",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1843.33 629.342C1843.33 629.342 1851.75 638.882 1861.57 634.915C1871.38 630.949 1867.72 619.486 1876.71 615.856C1885.69 612.227 1891.96 622.636 1900.84 619.05C1909.71 615.463 1910.09 602.37 1910.09 602.37",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1678.5 221.381C1678.5 221.381 1686.92 230.921 1696.74 226.954C1706.56 222.988 1702.9 211.525 1711.88 207.895C1720.86 204.266 1727.13 214.675 1736.01 211.089C1744.89 207.502 1745.26 194.409 1745.26 194.409",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810.36 547.75C1810.36 547.75 1818.78 557.29 1828.6 553.323C1838.42 549.357 1834.75 537.894 1843.74 534.264C1852.72 530.635 1858.99 541.044 1867.87 537.457C1876.75 533.871 1877.12 520.778 1877.12 520.778",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.43 384.565C1744.43 384.565 1752.85 394.105 1762.67 390.139C1772.49 386.172 1768.82 374.709 1777.81 371.08C1786.79 367.45 1793.06 377.86 1801.94 374.273C1810.82 370.686 1811.19 357.594 1811.19 357.594",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1942.22 874.119C1942.22 874.119 1950.64 883.658 1960.46 879.692C1970.28 875.725 1966.62 864.262 1975.6 860.633C1984.58 857.003 1990.85 867.413 1999.73 863.826C2008.61 860.239 2008.98 847.147 2008.98 847.147",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612.57 58.1968C1612.57 58.1968 1620.99 67.7364 1630.81 63.77C1640.63 59.8036 1636.97 48.3404 1645.95 44.7109C1654.93 41.0814 1661.2 51.4911 1670.08 47.9043C1678.96 44.3175 1679.33 31.2251 1679.33 31.2251",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.29 710.934C1876.29 710.934 1884.72 720.474 1894.53 716.507C1904.35 712.541 1900.69 701.078 1909.67 697.448C1918.65 693.819 1924.92 704.229 1933.8 700.642C1942.68 697.055 1943.05 683.963 1943.05 683.963",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1546.18 192.871C1546.18 192.871 1545.62 180.158 1555.43 176.192C1565.25 172.225 1570.58 183.015 1579.56 179.385C1588.55 175.756 1585.82 163.913 1594.7 160.326C1603.58 156.739 1612.94 165.899 1612.94 165.899",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1678.05 519.24C1678.05 519.24 1677.48 506.527 1687.3 502.561C1697.11 498.594 1702.44 509.383 1711.43 505.754C1720.41 502.124 1717.69 490.282 1726.56 486.695C1735.44 483.108 1744.8 492.268 1744.8 492.268",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612.12 356.055C1612.12 356.055 1611.55 343.343 1621.37 339.376C1631.18 335.41 1636.51 346.199 1645.5 342.57C1654.48 338.94 1651.76 327.097 1660.64 323.511C1669.51 319.924 1678.87 329.084 1678.87 329.084",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1809.91 845.609C1809.91 845.609 1809.34 832.896 1819.16 828.929C1828.97 824.963 1834.3 835.752 1843.28 832.123C1852.27 828.493 1849.55 816.65 1858.42 813.064C1867.3 809.477 1876.66 818.637 1876.66 818.637",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.25 29.6868C1480.25 29.6868 1479.69 16.974 1489.5 13.0076C1499.32 9.04115 1504.65 19.8304 1513.63 16.2009C1522.62 12.5714 1519.89 0.728672 1528.77 -2.85812C1537.65 -6.44492 1547.01 2.71509 1547.01 2.71509",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.98 682.424C1743.98 682.424 1743.41 669.711 1753.23 665.745C1763.04 661.779 1768.37 672.568 1777.36 668.938C1786.34 665.309 1783.62 653.466 1792.49 649.879C1801.37 646.292 1810.73 655.452 1810.73 655.452",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.15 274.463C1579.15 274.463 1578.58 261.75 1588.4 257.784C1598.21 253.818 1603.54 264.607 1612.53 260.977C1621.51 257.348 1618.79 245.505 1627.67 241.918C1636.54 238.332 1645.91 247.492 1645.91 247.492",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1711.01 600.832C1711.01 600.832 1710.44 588.119 1720.26 584.153C1730.08 580.186 1735.41 590.976 1744.39 587.346C1753.37 583.717 1750.65 571.874 1759.53 568.287C1768.41 564.7 1777.77 573.86 1777.77 573.86",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.08 437.648C1645.08 437.648 1644.51 424.935 1654.33 420.968C1664.15 417.002 1669.48 427.791 1678.46 424.162C1687.44 420.532 1684.72 408.689 1693.6 405.103C1702.48 401.516 1711.84 410.676 1711.84 410.676",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1842.88 927.201C1842.88 927.201 1842.31 914.488 1852.12 910.521C1861.94 906.555 1867.27 917.344 1876.25 913.715C1885.24 910.085 1882.52 898.243 1891.39 894.656C1900.27 891.069 1909.63 900.229 1909.63 900.229",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.22 111.279C1513.22 111.279 1512.65 98.5662 1522.47 94.5997C1532.28 90.6333 1537.61 101.423 1546.6 97.7931C1555.58 94.1636 1552.86 82.3208 1561.74 78.734C1570.61 75.1472 1579.98 84.3073 1579.98 84.3073",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1776.94 764.016C1776.94 764.016 1776.37 751.304 1786.19 747.337C1796.01 743.371 1801.34 754.16 1810.32 750.531C1819.3 746.901 1816.58 735.058 1825.46 731.471C1834.34 727.885 1843.7 737.045 1843.7 737.045",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1753.88 108.959C1753.88 108.959 1753.31 96.2465 1763.12 92.28C1772.94 88.3136 1778.27 99.1029 1787.25 95.4734C1796.24 91.8439 1793.52 80.0011 1802.39 76.4143C1811.27 72.8275 1820.63 81.9876 1820.63 81.9876",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1885.73 435.328C1885.73 435.328 1885.17 422.615 1894.98 418.649C1904.8 414.682 1910.13 425.472 1919.11 421.842C1928.1 418.213 1925.37 406.37 1934.25 402.783C1943.13 399.196 1952.49 408.356 1952.49 408.356",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2083.53 924.881C2083.53 924.881 2082.96 912.168 2092.78 908.202C2102.59 904.235 2107.92 915.025 2116.91 911.395C2125.89 907.766 2123.17 895.923 2132.05 892.336C2140.92 888.749 2150.28 897.909 2150.28 897.909",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1819.8 272.144C1819.8 272.144 1819.24 259.431 1829.05 255.464C1838.87 251.498 1844.2 262.287 1853.18 258.658C1862.17 255.028 1859.44 243.185 1868.32 239.599C1877.2 236.012 1886.56 245.172 1886.56 245.172",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2017.6 761.697C2017.6 761.697 2017.03 748.984 2026.85 745.017C2036.66 741.051 2041.99 751.84 2050.98 748.211C2059.96 744.581 2057.24 732.739 2066.12 729.152C2074.99 725.565 2084.35 734.725 2084.35 734.725",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1951.67 598.512C1951.67 598.512 1951.1 585.8 1960.92 581.833C1970.73 577.867 1976.06 588.656 1985.05 585.026C1994.03 581.397 1991.31 569.554 2000.19 565.967C2009.06 562.381 2018.43 571.541 2018.43 571.541",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.84 190.551C1786.84 190.551 1786.27 177.839 1796.09 173.872C1805.91 169.906 1811.24 180.695 1820.22 177.066C1829.2 173.436 1826.48 161.593 1835.36 158.007C1844.24 154.42 1853.6 163.58 1853.6 163.58",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1918.7 516.92C1918.7 516.92 1918.13 504.207 1927.95 500.241C1937.77 496.275 1943.09 507.064 1952.08 503.434C1961.06 499.805 1958.34 487.962 1967.22 484.375C1976.09 480.788 1985.46 489.948 1985.46 489.948",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1852.77 353.736C1852.77 353.736 1852.2 341.023 1862.02 337.057C1871.84 333.09 1877.16 343.879 1886.15 340.25C1895.13 336.62 1892.41 324.778 1901.29 321.191C1910.16 317.604 1919.53 326.764 1919.53 326.764",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2050.56 843.289C2050.56 843.289 2049.99 830.576 2059.81 826.61C2069.63 822.643 2074.96 833.432 2083.94 829.803C2092.92 826.173 2090.2 814.331 2099.08 810.744C2107.96 807.157 2117.32 816.317 2117.32 816.317",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720.91 27.3671C1720.91 27.3671 1720.34 14.6543 1730.16 10.6879C1739.98 6.72144 1745.31 17.5107 1754.29 13.8812C1763.27 10.2517 1760.55 -1.59103 1769.43 -5.17783C1778.31 -8.76462 1787.67 0.395388 1787.67 0.395388",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1984.63 680.104C1984.63 680.104 1984.06 667.392 1993.88 663.425C2003.7 659.459 2009.03 670.248 2018.01 666.619C2026.99 662.989 2024.27 651.146 2033.15 647.56C2042.03 643.973 2051.39 653.133 2051.39 653.133",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1957.07 13.9211C1957.07 13.9211 1965.49 23.4608 1975.31 19.4944C1985.12 15.5279 1981.46 4.0648 1990.45 0.435304C1999.43 -3.1942 2005.7 7.21546 2014.57 3.62866C2023.45 0.0418679 2023.82 -13.0505 2023.82 -13.0505",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2088.93 340.29C2088.93 340.29 2097.35 349.829 2107.17 345.863C2116.99 341.897 2113.32 330.433 2122.31 326.804C2131.29 323.174 2137.56 333.584 2146.44 329.997C2155.32 326.411 2155.69 313.318 2155.69 313.318",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2286.72 829.843C2286.72 829.843 2295.14 839.383 2304.96 835.416C2314.78 831.45 2311.12 819.987 2320.1 816.357C2329.08 812.728 2335.35 823.137 2344.23 819.55C2353.11 815.964 2353.48 802.871 2353.48 802.871",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2023 177.105C2023 177.105 2031.42 186.645 2041.24 182.679C2051.06 178.712 2047.4 167.249 2056.38 163.62C2065.36 159.99 2071.63 170.4 2080.51 166.813C2089.39 163.226 2089.76 150.134 2089.76 150.134",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2220.79 666.659C2220.79 666.659 2229.21 676.198 2239.03 672.232C2248.85 668.265 2245.18 656.802 2254.17 653.173C2263.15 649.543 2269.42 659.953 2278.3 656.366C2287.18 652.779 2287.55 639.687 2287.55 639.687",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2154.86 503.474C2154.86 503.474 2163.28 513.014 2173.1 509.047C2182.92 505.081 2179.25 493.618 2188.24 489.988C2197.22 486.359 2203.49 496.769 2212.37 493.182C2221.25 489.595 2221.62 476.503 2221.62 476.503",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1990.04 95.5133C1990.04 95.5133 1998.46 105.053 2008.27 101.087C2018.09 97.1201 2014.43 85.657 2023.41 82.0275C2032.4 78.398 2038.67 88.8076 2047.54 85.2208C2056.42 81.634 2056.79 68.5416 2056.79 68.5416",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2121.89 421.882C2121.89 421.882 2130.32 431.422 2140.13 427.455C2149.95 423.489 2146.29 412.026 2155.27 408.396C2164.26 404.767 2170.53 415.176 2179.4 411.59C2188.28 408.003 2188.65 394.91 2188.65 394.91",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2319.69 911.435C2319.69 911.435 2328.11 920.975 2337.93 917.008C2347.74 913.042 2344.08 901.579 2353.07 897.949C2362.05 894.32 2368.32 904.729 2377.2 901.143C2386.07 897.556 2386.44 884.463 2386.44 884.463",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2055.96 258.698C2055.96 258.698 2064.39 268.237 2074.2 264.271C2084.02 260.304 2080.36 248.841 2089.34 245.212C2098.33 241.582 2104.6 251.992 2113.47 248.405C2122.35 244.818 2122.72 231.726 2122.72 231.726",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2253.76 748.251C2253.76 748.251 2262.18 757.79 2272 753.824C2281.81 749.858 2278.15 738.394 2287.14 734.765C2296.12 731.135 2302.39 741.545 2311.27 737.958C2320.14 734.371 2320.52 721.279 2320.52 721.279",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2187.82 585.066C2187.82 585.066 2196.25 594.606 2206.06 590.64C2215.88 586.673 2212.22 575.21 2221.2 571.581C2230.19 567.951 2236.45 578.361 2245.33 574.774C2254.21 571.187 2254.58 558.095 2254.58 558.095",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1857.72 67.0033C1857.72 67.0033 1857.15 54.2905 1866.97 50.3241C1876.78 46.3577 1882.11 57.147 1891.1 53.5175C1900.08 49.888 1897.36 38.0452 1906.24 34.4584C1915.11 30.8716 1924.48 40.0316 1924.48 40.0316",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1989.58 393.372C1989.58 393.372 1989.01 380.659 1998.83 376.693C2008.64 372.726 2013.97 383.516 2022.96 379.886C2031.94 376.257 2029.22 364.414 2038.1 360.827C2046.97 357.24 2056.34 366.4 2056.34 366.4",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2187.37 882.925C2187.37 882.925 2186.8 870.212 2196.62 866.246C2206.44 862.279 2211.77 873.069 2220.75 869.439C2229.73 865.81 2227.01 853.967 2235.89 850.38C2244.77 846.793 2254.13 855.953 2254.13 855.953",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1923.65 230.188C1923.65 230.188 1923.08 217.475 1932.9 213.508C1942.71 209.542 1948.04 220.331 1957.03 216.702C1966.01 213.072 1963.29 201.23 1972.17 197.643C1981.04 194.056 1990.41 203.216 1990.41 203.216",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2121.44 719.741C2121.44 719.741 2120.87 707.028 2130.69 703.062C2140.51 699.095 2145.84 709.884 2154.82 706.255C2163.8 702.625 2161.08 690.783 2169.96 687.196C2178.84 683.609 2188.2 692.769 2188.2 692.769",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2055.51 556.556C2055.51 556.556 2054.94 543.844 2064.76 539.877C2074.58 535.911 2079.91 546.7 2088.89 543.071C2097.87 539.441 2095.15 527.598 2104.03 524.012C2112.91 520.425 2122.27 529.585 2122.27 529.585",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890.68 148.595C1890.68 148.595 1890.12 135.883 1899.93 131.916C1909.75 127.95 1915.08 138.739 1924.06 135.11C1933.05 131.48 1930.32 119.637 1939.2 116.051C1948.08 112.464 1957.44 121.624 1957.44 121.624",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2022.55 474.964C2022.55 474.964 2021.98 462.251 2031.8 458.285C2041.61 454.318 2046.94 465.108 2055.93 461.478C2064.91 457.849 2062.19 446.006 2071.06 442.419C2079.94 438.832 2089.3 447.992 2089.3 447.992",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2220.34 964.517C2220.34 964.517 2219.77 951.804 2229.58 947.838C2239.4 943.872 2244.73 954.661 2253.71 951.031C2262.7 947.402 2259.98 935.559 2268.85 931.972C2277.73 928.386 2287.09 937.546 2287.09 937.546",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1956.61 311.78C1956.61 311.78 1956.04 299.067 1965.86 295.101C1975.68 291.134 1981.01 301.923 1989.99 298.294C1998.98 294.664 1996.25 282.822 2005.13 279.235C2014.01 275.648 2023.37 284.808 2023.37 284.808",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2154.41 801.333C2154.41 801.333 2153.84 788.62 2163.66 784.654C2173.47 780.687 2178.8 791.477 2187.78 787.847C2196.77 784.218 2194.05 772.375 2202.92 768.788C2211.8 765.201 2221.16 774.361 2221.16 774.361",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2088.48 638.149C2088.48 638.149 2087.91 625.436 2097.73 621.469C2107.54 617.503 2112.87 628.292 2121.86 624.663C2130.84 621.033 2128.12 609.19 2136.99 605.604C2145.87 602.017 2155.23 611.177 2155.23 611.177",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2197.27 309.46C2197.27 309.46 2196.7 296.747 2206.52 292.781C2216.34 288.814 2221.66 299.604 2230.65 295.974C2239.63 292.345 2236.91 280.502 2245.79 276.915C2254.66 273.328 2264.03 282.488 2264.03 282.488",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2395.06 799.013C2395.06 799.013 2394.49 786.3 2404.31 782.334C2414.13 778.368 2419.46 789.157 2428.44 785.527C2437.42 781.898 2434.7 770.055 2443.58 766.468C2452.46 762.881 2461.82 772.042 2461.82 772.042",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2131.34 146.276C2131.34 146.276 2130.77 133.563 2140.59 129.597C2150.41 125.63 2155.74 136.419 2164.72 132.79C2173.7 129.16 2170.98 117.318 2179.86 113.731C2188.74 110.144 2198.1 119.304 2198.1 119.304",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2329.13 635.829C2329.13 635.829 2328.56 623.116 2338.38 619.15C2348.2 615.183 2353.52 625.973 2362.51 622.343C2371.49 618.714 2368.77 606.871 2377.65 603.284C2386.52 599.697 2395.89 608.857 2395.89 608.857",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2263.2 472.645C2263.2 472.645 2262.63 459.932 2272.45 455.965C2282.27 451.999 2287.59 462.788 2296.58 459.159C2305.56 455.529 2302.84 443.686 2311.72 440.1C2320.59 436.513 2329.96 445.673 2329.96 445.673",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.99 962.198C2460.99 962.198 2460.42 949.485 2470.24 945.518C2480.06 941.552 2485.39 952.341 2494.37 948.712C2503.35 945.082 2500.63 933.239 2509.51 929.653C2518.39 926.066 2527.75 935.226 2527.75 935.226",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2098.38 64.6836C2098.38 64.6836 2097.81 51.9708 2107.62 48.0044C2117.44 44.038 2122.77 54.8273 2131.75 51.1978C2140.74 47.5683 2138.02 35.7255 2146.89 32.1387C2155.77 28.5519 2165.13 37.7119 2165.13 37.7119",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2230.23 391.052C2230.23 391.052 2229.67 378.339 2239.48 374.373C2249.3 370.407 2254.63 381.196 2263.61 377.566C2272.6 373.937 2269.87 362.094 2278.75 358.507C2287.63 354.921 2296.99 364.081 2296.99 364.081",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2428.03 880.605C2428.03 880.605 2427.46 867.893 2437.28 863.926C2447.09 859.96 2452.42 870.749 2461.41 867.12C2470.39 863.49 2467.67 851.647 2476.55 848.061C2485.42 844.474 2494.78 853.634 2494.78 853.634",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2164.3 227.868C2164.3 227.868 2163.74 215.155 2173.55 211.189C2183.37 207.222 2188.7 218.012 2197.68 214.382C2206.67 210.753 2203.94 198.91 2212.82 195.323C2221.7 191.736 2231.06 200.896 2231.06 200.896",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2362.1 717.421C2362.1 717.421 2361.53 704.708 2371.35 700.742C2381.16 696.775 2386.49 707.565 2395.48 703.935C2404.46 700.306 2401.74 688.463 2410.62 684.876C2419.49 681.289 2428.85 690.449 2428.85 690.449",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2296.16 554.237C2296.16 554.237 2295.6 541.524 2305.41 537.557C2315.23 533.591 2320.56 544.38 2329.54 540.751C2338.53 537.121 2335.8 525.279 2344.68 521.692C2353.56 518.105 2362.92 527.265 2362.92 527.265",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2400.46 214.422C2400.46 214.422 2408.89 223.962 2418.7 219.995C2428.52 216.029 2424.86 204.566 2433.84 200.936C2442.83 197.307 2449.1 207.716 2457.97 204.13C2466.85 200.543 2467.22 187.45 2467.22 187.45",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2334.53 51.2377C2334.53 51.2377 2342.95 60.7773 2352.77 56.8109C2362.59 52.8445 2358.93 41.3813 2367.91 37.7518C2376.89 34.1223 2383.16 44.532 2392.04 40.9452C2400.92 37.3584 2401.29 24.266 2401.29 24.266",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2466.39 377.606C2466.39 377.606 2474.82 387.146 2484.63 383.18C2494.45 379.213 2490.79 367.75 2499.77 364.121C2508.76 360.491 2515.03 370.901 2523.9 367.314C2532.78 363.727 2533.15 350.635 2533.15 350.635",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2433.43 296.014C2433.43 296.014 2441.85 305.554 2451.67 301.587C2461.49 297.621 2457.82 286.158 2466.81 282.528C2475.79 278.899 2482.06 289.308 2490.94 285.722C2499.82 282.135 2500.19 269.042 2500.19 269.042",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2367.5 132.83C2367.5 132.83 2375.92 142.369 2385.74 138.403C2395.55 134.437 2391.89 122.973 2400.87 119.344C2409.86 115.714 2416.13 126.124 2425 122.537C2433.88 118.951 2434.25 105.858 2434.25 105.858",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2301.11 267.504C2301.11 267.504 2300.54 254.791 2310.36 250.825C2320.18 246.859 2325.51 257.648 2334.49 254.018C2343.48 250.389 2340.75 238.546 2349.63 234.959C2358.51 231.372 2367.87 240.532 2367.87 240.532",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2498.91 757.057C2498.91 757.057 2498.34 744.344 2508.16 740.378C2517.97 736.412 2523.3 747.201 2532.28 743.571C2541.27 739.942 2538.55 728.099 2547.42 724.512C2556.3 720.926 2565.66 730.086 2565.66 730.086",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2235.18 104.32C2235.18 104.32 2234.62 91.607 2244.43 87.6406C2254.25 83.6742 2259.58 94.4635 2268.56 90.834C2277.55 87.2045 2274.82 75.3617 2283.7 71.7749C2292.58 68.1881 2301.94 77.3481 2301.94 77.3481",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2432.98 593.873C2432.98 593.873 2432.41 581.16 2442.23 577.194C2452.04 573.227 2457.37 584.017 2466.36 580.387C2475.34 576.758 2472.62 564.915 2481.49 561.328C2490.37 557.741 2499.73 566.901 2499.73 566.901",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2367.04 430.689C2367.04 430.689 2366.47 417.976 2376.29 414.009C2386.11 410.043 2391.44 420.832 2400.42 417.203C2409.4 413.573 2406.68 401.731 2415.56 398.144C2424.44 394.557 2433.8 403.717 2433.8 403.717",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2202.22 22.7277C2202.22 22.7277 2201.65 10.0149 2211.47 6.04846C2221.28 2.08204 2226.61 12.8713 2235.6 9.24182C2244.58 5.61232 2241.86 -6.23043 2250.74 -9.81723C2259.61 -13.404 2268.98 -4.24402 2268.98 -4.24402",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2334.08 349.096C2334.08 349.096 2333.51 336.384 2343.33 332.417C2353.14 328.451 2358.47 339.24 2367.46 335.61C2376.44 331.981 2373.72 320.138 2382.6 316.551C2391.47 312.965 2400.84 322.125 2400.84 322.125",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2268.15 185.912C2268.15 185.912 2267.58 173.199 2277.4 169.233C2287.21 165.266 2292.54 176.056 2301.53 172.426C2310.51 168.797 2307.79 156.954 2316.67 153.367C2325.54 149.78 2334.91 158.94 2334.91 158.94",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2465.94 675.465C2465.94 675.465 2465.37 662.752 2475.19 658.786C2485.01 654.819 2490.34 665.609 2499.32 661.979C2508.3 658.35 2505.58 646.507 2514.46 642.92C2523.34 639.333 2532.7 648.493 2532.7 648.493",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2400.01 512.281C2400.01 512.281 2399.44 499.568 2409.26 495.602C2419.08 491.635 2424.41 502.424 2433.39 498.795C2442.37 495.165 2439.65 483.323 2448.53 479.736C2457.41 476.149 2466.77 485.309 2466.77 485.309",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2442.87 20.408C2442.87 20.408 2442.3 7.69518 2452.12 3.72876C2461.94 -0.237662 2467.27 10.5516 2476.25 6.92212C2485.23 3.29262 2482.51 -8.55014 2491.39 -12.1369C2500.27 -15.7237 2509.63 -6.56372 2509.63 -6.56372",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2475.84 102C2475.84 102 2475.27 89.2873 2485.08 85.3209C2494.9 81.3545 2500.23 92.1438 2509.21 88.5143C2518.2 84.8848 2515.48 73.042 2524.35 69.4552C2533.23 65.8684 2542.59 75.0284 2542.59 75.0284",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.3477 873.233C-52.3477 873.233 -43.9255 882.772 -34.1082 878.806C-24.291 874.839 -27.9524 863.376 -18.969 859.747C-9.98571 856.117 -3.71691 866.527 5.16072 862.94C14.0384 859.353 14.4096 846.261 14.4096 846.261",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.3789 954.825C-19.3789 954.825 -10.9567 964.364 -1.13949 960.398C8.67775 956.432 5.01639 944.968 13.9997 941.339C22.983 937.709 29.2518 948.119 38.1295 944.532C47.0071 940.945 47.3783 927.853 47.3783 927.853",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4141 626.136C89.4141 626.136 97.8362 635.676 107.653 631.71C117.471 627.743 113.809 616.28 122.793 612.651C131.776 609.021 138.045 619.431 146.922 615.844C155.8 612.257 156.171 599.165 156.171 599.165",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-42.4492 299.768C-42.4492 299.768 -34.027 309.307 -24.2098 305.341C-14.3926 301.374 -18.0539 289.911 -9.0706 286.282C-0.0872727 282.652 6.18153 293.062 15.0592 289.475C23.9368 285.888 24.308 272.796 24.308 272.796",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.273 952.505C221.273 952.505 229.696 962.045 239.513 958.078C249.33 954.112 245.669 942.649 254.652 939.019C263.635 935.39 269.904 945.799 278.782 942.213C287.659 938.626 288.031 925.533 288.031 925.533",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.344 789.321C155.344 789.321 163.766 798.86 173.583 794.894C183.4 790.928 179.739 779.464 188.722 775.835C197.706 772.205 203.975 782.615 212.852 779.028C221.73 775.441 222.101 762.349 222.101 762.349",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4805 462.952C23.4805 462.952 31.9026 472.492 41.7199 468.525C51.5371 464.559 47.8758 453.096 56.8591 449.466C65.8424 445.837 72.1112 456.246 80.9889 452.66C89.8665 449.073 90.2377 435.98 90.2377 435.98",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.379 707.729C122.379 707.729 130.801 717.268 140.618 713.302C150.436 709.335 146.774 697.872 155.758 694.243C164.741 690.613 171.01 701.023 179.887 697.436C188.765 693.849 189.136 680.757 189.136 680.757",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.48438 381.36C-9.48438 381.36 -1.0622 390.9 8.75504 386.933C18.5723 382.967 14.9109 371.504 23.8942 367.874C32.8776 364.245 39.1464 374.654 48.024 371.067C56.9016 367.481 57.2729 354.388 57.2729 354.388",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.309 870.913C188.309 870.913 196.731 880.453 206.548 876.486C216.365 872.52 212.704 861.057 221.687 857.427C230.671 853.798 236.939 864.207 245.817 860.62C254.695 857.034 255.066 843.941 255.066 843.941",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4453 544.544C56.4453 544.544 64.8675 554.084 74.6847 550.117C84.502 546.151 80.8406 534.688 89.8239 531.058C98.8073 527.429 105.076 537.839 113.954 534.252C122.831 530.665 123.203 517.573 123.203 517.573",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.324 332.445C816.324 332.445 824.746 341.984 834.564 338.018C844.381 334.052 840.72 322.588 849.703 318.959C858.686 315.329 864.955 325.739 873.833 322.152C882.71 318.566 883.081 305.473 883.081 305.473",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.461 6.07605C684.461 6.07605 692.883 15.6157 702.7 11.6493C712.518 7.68284 708.856 -3.78029 717.84 -7.40979C726.823 -11.0393 733.092 -0.629632 741.969 -4.21643C750.847 -7.80322 751.218 -20.8956 751.218 -20.8956",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.188 658.813C948.188 658.813 956.61 668.353 966.427 664.387C976.244 660.42 972.583 648.957 981.566 645.328C990.549 641.698 996.818 652.108 1005.7 648.521C1014.57 644.934 1014.94 631.842 1014.94 631.842",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.254 495.629C882.254 495.629 890.676 505.169 900.493 501.202C910.311 497.236 906.649 485.773 915.633 482.143C924.616 478.514 930.885 488.923 939.762 485.337C948.64 481.75 949.011 468.657 949.011 468.657",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.395 169.26C750.395 169.26 758.817 178.8 768.634 174.834C778.451 170.867 774.79 159.404 783.773 155.775C792.756 152.145 799.025 162.555 807.903 158.968C816.781 155.381 817.152 142.289 817.152 142.289",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.12 821.998C1014.12 821.998 1022.54 831.538 1032.36 827.571C1042.17 823.605 1038.51 812.142 1047.5 808.512C1056.48 804.883 1062.75 815.292 1071.63 811.705C1080.5 808.119 1080.87 795.026 1080.87 795.026",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.289 414.037C849.289 414.037 857.711 423.577 867.528 419.61C877.346 415.644 873.684 404.181 882.668 400.551C891.651 396.922 897.92 407.331 906.797 403.745C915.675 400.158 916.046 387.065 916.046 387.065",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.43 87.6682C717.43 87.6682 725.852 97.2079 735.669 93.2414C745.486 89.275 741.825 77.8119 750.808 74.1824C759.792 70.5529 766.06 80.9625 774.938 77.3757C783.816 73.7889 784.187 60.6965 784.187 60.6965",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.152 740.406C981.152 740.406 989.575 749.945 999.392 745.979C1009.21 742.012 1005.55 730.549 1014.53 726.92C1023.51 723.29 1029.78 733.7 1038.66 730.113C1047.54 726.526 1047.91 713.434 1047.91 713.434",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.219 577.221C915.219 577.221 923.641 586.761 933.458 582.795C943.275 578.828 939.614 567.365 948.597 563.735C957.581 560.106 963.85 570.516 972.727 566.929C981.605 563.342 981.976 550.25 981.976 550.25",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.359 250.853C783.359 250.853 791.782 260.392 801.599 256.426C811.416 252.459 807.755 240.996 816.738 237.367C825.721 233.737 831.99 244.147 840.868 240.56C849.745 236.973 850.117 223.881 850.117 223.881",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.08 903.59C1047.08 903.59 1055.5 913.13 1065.32 909.163C1075.14 905.197 1071.48 893.734 1080.46 890.104C1089.44 886.475 1095.71 896.884 1104.59 893.298C1113.47 889.711 1113.84 876.618 1113.84 876.618",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.9375 679.219C-9.9375 679.219 -10.5059 666.506 -0.688641 662.539C9.1286 658.573 14.4578 669.362 23.4411 665.733C32.4244 662.103 29.7027 650.26 38.5803 646.674C47.458 643.087 56.8197 652.247 56.8197 652.247",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9922 842.403C55.9922 842.403 55.4238 829.69 65.241 825.724C75.0583 821.757 80.3875 832.547 89.3708 828.917C98.3541 825.288 95.6324 813.445 104.51 809.858C113.388 806.271 122.749 815.431 122.749 815.431",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 760.811C23.0273 760.811 22.459 748.098 32.2762 744.131C42.0934 740.165 47.4226 750.954 56.406 747.325C65.3893 743.695 62.6675 731.853 71.5452 728.266C80.4228 724.679 89.7846 733.839 89.7846 733.839",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9609 923.995C88.9609 923.995 88.3926 911.282 98.2098 907.316C108.027 903.349 113.356 914.139 122.34 910.509C131.323 906.88 128.601 895.037 137.479 891.45C146.356 887.863 155.718 897.023 155.718 897.023",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-42.9023 597.626C-42.9023 597.626 -43.4707 584.914 -33.6535 580.947C-23.8362 576.981 -18.507 587.77 -9.52372 584.141C-0.540398 580.511 -3.26215 568.668 5.61548 565.081C14.4931 561.495 23.8549 570.655 23.8549 570.655",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.977 385.527C716.977 385.527 716.408 372.814 726.225 368.848C736.043 364.881 741.372 375.671 750.355 372.041C759.339 368.412 756.617 356.569 765.494 352.982C774.372 349.395 783.734 358.555 783.734 358.555",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.113 59.1582C585.113 59.1582 584.545 46.4454 594.362 42.479C604.179 38.5126 609.509 49.3019 618.492 45.6724C627.475 42.0429 624.753 30.2001 633.631 26.6133C642.509 23.0265 651.871 32.1865 651.871 32.1865",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.836 711.896C848.836 711.896 848.268 699.183 858.085 695.216C867.902 691.25 873.231 702.039 882.215 698.41C891.198 694.78 888.476 682.938 897.354 679.351C906.231 675.764 915.593 684.924 915.593 684.924",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.906 548.711C782.906 548.711 782.338 535.999 792.155 532.032C801.972 528.066 807.302 538.855 816.285 535.225C825.268 531.596 822.546 519.753 831.424 516.166C840.302 512.58 849.663 521.74 849.663 521.74",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.043 222.343C651.043 222.343 650.475 209.63 660.292 205.663C670.109 201.697 675.438 212.486 684.422 208.857C693.405 205.227 690.683 193.384 699.561 189.798C708.438 186.211 717.8 195.371 717.8 195.371",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.766 875.08C914.766 875.08 914.197 862.367 924.014 858.401C933.832 854.434 939.161 865.224 948.144 861.594C957.128 857.965 954.406 846.122 963.283 842.535C972.161 838.948 981.523 848.108 981.523 848.108",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.941 467.119C749.941 467.119 749.373 454.406 759.19 450.44C769.008 446.474 774.337 457.263 783.32 453.633C792.303 450.004 789.582 438.161 798.459 434.574C807.337 430.987 816.699 440.147 816.699 440.147",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.078 140.75C618.078 140.75 617.51 128.038 627.327 124.071C637.144 120.105 642.473 130.894 651.457 127.265C660.44 123.635 657.718 111.792 666.596 108.205C675.474 104.619 684.835 113.779 684.835 113.779",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.801 793.488C881.801 793.488 881.232 780.775 891.05 776.809C900.867 772.842 906.196 783.632 915.179 780.002C924.163 776.373 921.441 764.53 930.319 760.943C939.196 757.356 948.558 766.516 948.558 766.516",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.871 630.303C815.871 630.303 815.303 617.591 825.12 613.624C834.937 609.658 840.266 620.447 849.25 616.818C858.233 613.188 855.511 601.345 864.389 597.759C873.267 594.172 882.628 603.332 882.628 603.332",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.008 303.935C684.008 303.935 683.439 291.222 693.257 287.256C703.074 283.289 708.403 294.078 717.386 290.449C726.37 286.819 723.648 274.977 732.526 271.39C741.403 267.803 750.765 276.963 750.765 276.963",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.734 956.672C947.734 956.672 947.166 943.959 956.983 939.993C966.8 936.027 972.13 946.816 981.113 943.186C990.096 939.557 987.375 927.714 996.252 924.127C1005.13 920.54 1014.49 929.701 1014.49 929.701",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.754 595.307C197.754 595.307 197.186 582.594 207.003 578.627C216.82 574.661 222.149 585.45 231.133 581.821C240.116 578.191 237.394 566.349 246.272 562.762C255.149 559.175 264.511 568.335 264.511 568.335",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8906 268.938C65.8906 268.938 65.3222 256.225 75.1395 252.259C84.9567 248.292 90.2859 259.082 99.2692 255.452C108.253 251.823 105.531 239.98 114.408 236.393C123.286 232.806 132.648 241.966 132.648 241.966",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.613 921.675C329.613 921.675 329.045 908.963 338.862 904.996C348.679 901.03 354.009 911.819 362.992 908.19C371.975 904.56 369.253 892.717 378.131 889.13C387.009 885.544 396.371 894.704 396.371 894.704",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0390625 105.754C-0.0390625 105.754 -0.607445 93.0408 9.2098 89.0743C19.027 85.1079 24.3562 95.8972 33.3396 92.2677C42.3229 88.6382 39.6011 76.7954 48.4788 73.2086C57.3564 69.6219 66.7182 78.7819 66.7182 78.7819",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.684 758.491C263.684 758.491 263.115 745.778 272.932 741.812C282.75 737.845 288.079 748.635 297.062 745.005C306.046 741.376 303.324 729.533 312.201 725.946C321.079 722.359 330.441 731.519 330.441 731.519",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.82 432.122C131.82 432.122 131.252 419.41 141.069 415.443C150.886 411.477 156.216 422.266 165.199 418.636C174.182 415.007 171.461 403.164 180.338 399.577C189.216 395.991 198.578 405.151 198.578 405.151",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-33.0039 24.1614C-33.0039 24.1614 -33.5723 11.4486 -23.755 7.48218C-13.9378 3.51576 -8.60861 14.305 0.374715 10.6755C9.35804 7.04604 6.63629 -4.79672 15.5139 -8.38351C24.3916 -11.9703 33.7533 -2.8103 33.7533 -2.8103",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.719 676.899C230.719 676.899 230.15 664.186 239.968 660.22C249.785 656.253 255.114 667.042 264.097 663.413C273.081 659.783 270.359 647.941 279.237 644.354C288.114 640.767 297.476 649.927 297.476 649.927",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8555 350.53C98.8555 350.53 98.2871 337.817 108.104 333.851C117.922 329.884 123.251 340.674 132.234 337.044C141.217 333.415 138.496 321.572 147.373 317.985C156.251 314.398 165.613 323.558 165.613 323.558",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9258 187.346C32.9258 187.346 32.3574 174.633 42.1746 170.667C51.9919 166.7 57.3211 177.489 66.3044 173.86C75.2877 170.23 72.566 158.388 81.4436 154.801C90.3212 151.214 99.683 160.374 99.683 160.374",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.648 840.083C296.648 840.083 296.08 827.37 305.897 823.404C315.715 819.438 321.044 830.227 330.027 826.597C339.01 822.968 336.289 811.125 345.166 807.538C354.044 803.952 363.406 813.112 363.406 813.112",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.785 513.714C164.785 513.714 164.217 501.002 174.034 497.035C183.851 493.069 189.18 503.858 198.164 500.229C207.147 496.599 204.425 484.756 213.303 481.17C222.181 477.583 231.542 486.743 231.542 486.743",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.664 301.615C924.664 301.615 924.096 288.902 933.913 284.936C943.73 280.969 949.059 291.759 958.043 288.129C967.026 284.5 964.304 272.657 973.182 269.07C982.06 265.483 991.421 274.643 991.421 274.643",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.53 627.984C1056.53 627.984 1055.96 615.271 1065.78 611.305C1075.59 607.338 1080.92 618.127 1089.91 614.498C1098.89 610.868 1096.17 599.026 1105.05 595.439C1113.92 591.852 1123.28 601.012 1123.28 601.012",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.594 464.799C990.594 464.799 990.025 452.087 999.843 448.12C1009.66 444.154 1014.99 454.943 1023.97 451.314C1032.96 447.684 1030.23 435.841 1039.11 432.255C1047.99 428.668 1057.35 437.828 1057.35 437.828",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.39 954.353C1188.39 954.353 1187.82 941.64 1197.64 937.673C1207.45 933.707 1212.78 944.496 1221.77 940.867C1230.75 937.237 1228.03 925.394 1236.9 921.808C1245.78 918.221 1255.14 927.381 1255.14 927.381",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.734 138.431C858.734 138.431 858.166 125.718 867.983 121.751C877.8 117.785 883.13 128.574 892.113 124.945C901.096 121.315 898.375 109.473 907.252 105.886C916.13 102.299 925.492 111.459 925.492 111.459",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.46 791.168C1122.46 791.168 1121.89 778.455 1131.71 774.489C1141.52 770.523 1146.85 781.312 1155.84 777.682C1164.82 774.053 1162.1 762.21 1170.97 758.623C1179.85 755.036 1189.21 764.196 1189.21 764.196",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.629 383.207C957.629 383.207 957.061 370.494 966.878 366.528C976.695 362.562 982.024 373.351 991.008 369.721C999.991 366.092 997.269 354.249 1006.15 350.662C1015.02 347.076 1024.39 356.236 1024.39 356.236",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.77 56.8385C825.77 56.8385 825.201 44.1257 835.018 40.1593C844.836 36.1929 850.165 46.9822 859.148 43.3527C868.131 39.7232 865.41 27.8804 874.287 24.2936C883.165 20.7068 892.527 29.8668 892.527 29.8668",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.49 709.576C1089.49 709.576 1088.92 696.863 1098.74 692.897C1108.56 688.93 1113.89 699.72 1122.87 696.09C1131.85 692.461 1129.13 680.618 1138.01 677.031C1146.89 673.444 1156.25 682.604 1156.25 682.604",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.56 546.392C1023.56 546.392 1022.99 533.679 1032.81 529.712C1042.62 525.746 1047.95 536.535 1056.94 532.906C1065.92 529.276 1063.2 517.434 1072.08 513.847C1080.95 510.26 1090.32 519.42 1090.32 519.42",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.699 220.023C891.699 220.023 891.131 207.31 900.948 203.344C910.765 199.377 916.095 210.167 925.078 206.537C934.061 202.908 931.339 191.065 940.217 187.478C949.095 183.891 958.456 193.051 958.456 193.051",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.42 872.76C1155.42 872.76 1154.85 860.048 1164.67 856.081C1174.49 852.115 1179.82 862.904 1188.8 859.274C1197.78 855.645 1195.06 843.802 1203.94 840.215C1212.82 836.629 1222.18 845.789 1222.18 845.789",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.102 542.224C297.102 542.224 305.524 551.764 315.341 547.798C325.158 543.831 321.497 532.368 330.48 528.739C339.464 525.109 345.732 535.519 354.61 531.932C363.488 528.345 363.859 515.253 363.859 515.253",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.238 215.856C165.238 215.856 173.66 225.395 183.478 221.429C193.295 217.463 189.634 205.999 198.617 202.37C207.6 198.74 213.869 209.15 222.747 205.563C231.624 201.976 231.996 188.884 231.996 188.884",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.965 868.593C428.965 868.593 437.387 878.133 447.204 874.166C457.022 870.2 453.36 858.737 462.343 855.107C471.327 851.478 477.596 861.888 486.473 858.301C495.351 854.714 495.722 841.622 495.722 841.622",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3086 52.6714C99.3086 52.6714 107.731 62.211 117.548 58.2446C127.365 54.2782 123.704 42.815 132.687 39.1855C141.671 35.556 147.939 45.9657 156.817 42.3789C165.695 38.7921 166.066 25.6997 166.066 25.6997",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.031 705.409C363.031 705.409 371.453 714.949 381.271 710.982C391.088 707.016 387.427 695.553 396.41 691.923C405.393 688.294 411.662 698.703 420.54 695.116C429.417 691.53 429.788 678.437 429.788 678.437",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.172 379.04C231.172 379.04 239.594 388.58 249.411 384.613C259.229 380.647 255.567 369.184 264.55 365.554C273.534 361.925 279.803 372.334 288.68 368.748C297.558 365.161 297.929 352.068 297.929 352.068",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.066 623.817C330.066 623.817 338.489 633.356 348.306 629.39C358.123 625.423 354.462 613.96 363.445 610.331C372.428 606.701 378.697 617.111 387.575 613.524C396.452 609.937 396.824 596.845 396.824 596.845",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.207 297.448C198.207 297.448 206.629 306.988 216.446 303.021C226.264 299.055 222.602 287.592 231.586 283.962C240.569 280.333 246.838 290.742 255.715 287.156C264.593 283.569 264.964 270.476 264.964 270.476",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.93 950.185C461.93 950.185 470.352 959.725 480.169 955.759C489.986 951.792 486.325 940.329 495.308 936.7C504.292 933.07 510.56 943.48 519.438 939.893C528.316 936.306 528.687 923.214 528.687 923.214",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.273 134.264C132.273 134.264 140.696 143.803 150.513 139.837C160.33 135.87 156.669 124.407 165.652 120.778C174.635 117.148 180.904 127.558 189.782 123.971C198.659 120.384 199.031 107.292 199.031 107.292",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.996 787.001C395.996 787.001 404.418 796.541 414.236 792.574C424.053 788.608 420.391 777.145 429.375 773.515C438.358 769.886 444.627 780.295 453.504 776.709C462.382 773.122 462.753 760.029 462.753 760.029",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.137 460.632C264.137 460.632 272.559 470.172 282.376 466.206C292.193 462.239 288.532 450.776 297.515 447.146C306.499 443.517 312.767 453.927 321.645 450.34C330.523 446.753 330.894 433.661 330.894 433.661",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.01 248.533C1024.01 248.533 1032.43 258.073 1042.25 254.106C1052.07 250.14 1048.41 238.677 1057.39 235.047C1066.37 231.418 1072.64 241.827 1081.52 238.24C1090.4 234.654 1090.77 221.561 1090.77 221.561",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.95 411.717C1089.95 411.717 1098.37 421.257 1108.18 417.29C1118 413.324 1114.34 401.861 1123.32 398.231C1132.31 394.602 1138.58 405.012 1147.45 401.425C1156.33 397.838 1156.7 384.746 1156.7 384.746",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.74 901.27C1287.74 901.27 1296.16 910.81 1305.98 906.844C1315.79 902.877 1312.13 891.414 1321.12 887.785C1330.1 884.155 1336.37 894.565 1345.25 890.978C1354.12 887.391 1354.5 874.299 1354.5 874.299",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.082 85.3485C958.082 85.3485 966.504 94.8881 976.321 90.9217C986.139 86.9553 982.477 75.4922 991.461 71.8627C1000.44 68.2332 1006.71 78.6428 1015.59 75.056C1024.47 71.4692 1024.84 58.3768 1024.84 58.3768",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.8 738.086C1221.8 738.086 1230.23 747.626 1240.04 743.659C1249.86 739.693 1246.2 728.23 1255.18 724.6C1264.17 720.971 1270.44 731.38 1279.31 727.794C1288.19 724.207 1288.56 711.114 1288.56 711.114",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.98 330.125C1056.98 330.125 1065.4 339.665 1075.22 335.698C1085.04 331.732 1081.38 320.269 1090.36 316.639C1099.34 313.01 1105.61 323.419 1114.49 319.833C1123.37 316.246 1123.74 303.153 1123.74 303.153",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.117 3.75635C925.117 3.75635 933.539 13.296 943.357 9.32956C953.174 5.36314 949.512 -6.09999 958.496 -9.72949C967.479 -13.359 973.748 -2.94933 982.626 -6.53613C991.503 -10.1229 991.874 -23.2153 991.874 -23.2153",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.84 656.494C1188.84 656.494 1197.26 666.033 1207.08 662.067C1216.9 658.101 1213.24 646.637 1222.22 643.008C1231.2 639.378 1237.47 649.788 1246.35 646.201C1255.23 642.614 1255.6 629.522 1255.6 629.522",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.047 166.941C991.047 166.941 999.469 176.48 1009.29 172.514C1019.1 168.548 1015.44 157.084 1024.43 153.455C1033.41 149.825 1039.68 160.235 1048.56 156.648C1057.43 153.062 1057.8 139.969 1057.8 139.969",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.77 819.678C1254.77 819.678 1263.19 829.218 1273.01 825.251C1282.83 821.285 1279.16 809.822 1288.15 806.192C1297.13 802.563 1303.4 812.972 1312.28 809.386C1321.16 805.799 1321.53 792.706 1321.53 792.706",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.789 458.313C504.789 458.313 513.211 467.852 523.028 463.886C532.846 459.919 529.184 448.456 538.168 444.827C547.151 441.197 553.42 451.607 562.297 448.02C571.175 444.433 571.546 431.341 571.546 431.341",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.93 131.944C372.93 131.944 381.352 141.483 391.169 137.517C400.986 133.551 397.325 122.088 406.308 118.458C415.292 114.829 421.56 125.238 430.438 121.651C439.316 118.065 439.687 104.972 439.687 104.972",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.652 784.681C636.652 784.681 645.075 794.221 654.892 790.255C664.709 786.288 661.048 774.825 670.031 771.195C679.014 767.566 685.283 777.976 694.161 774.389C703.038 770.802 703.41 757.71 703.41 757.71",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.723 621.497C570.723 621.497 579.145 631.037 588.962 627.07C598.779 623.104 595.118 611.641 604.101 608.011C613.085 604.382 619.353 614.791 628.231 611.204C637.109 607.618 637.48 594.525 637.48 594.525",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.859 295.128C438.859 295.128 447.282 304.668 457.099 300.702C466.916 296.735 463.255 285.272 472.238 281.642C481.221 278.013 487.49 288.423 496.368 284.836C505.245 281.249 505.617 268.157 505.617 268.157",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.582 947.866C702.582 947.866 711.004 957.405 720.821 953.439C730.639 949.473 726.977 938.009 735.961 934.38C744.944 930.75 751.213 941.16 760.09 937.573C768.968 933.986 769.339 920.894 769.339 920.894",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.758 539.905C537.758 539.905 546.18 549.444 555.997 545.478C565.814 541.512 562.153 530.048 571.136 526.419C580.12 522.789 586.389 533.199 595.266 529.612C604.144 526.026 604.515 512.933 604.515 512.933",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.895 213.536C405.895 213.536 414.317 223.076 424.134 219.109C433.951 215.143 430.29 203.68 439.273 200.05C448.256 196.421 454.525 206.83 463.403 203.244C472.281 199.657 472.652 186.564 472.652 186.564",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.617 866.273C669.617 866.273 678.039 875.813 687.857 871.847C697.674 867.88 694.012 856.417 702.996 852.788C711.979 849.158 718.248 859.568 727.126 855.981C736.003 852.394 736.374 839.302 736.374 839.302",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.965 50.3517C339.965 50.3517 348.387 59.8913 358.204 55.9249C368.022 51.9585 364.36 40.4953 373.343 36.8658C382.327 33.2363 388.596 43.646 397.473 40.0592C406.351 36.4724 406.722 23.38 406.722 23.38",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.688 703.089C603.688 703.089 612.11 712.629 621.927 708.662C631.744 704.696 628.083 693.233 637.066 689.603C646.049 685.974 652.318 696.383 661.196 692.797C670.074 689.21 670.445 676.117 670.445 676.117",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.824 376.72C471.824 376.72 480.246 386.26 490.064 382.294C499.881 378.327 496.22 366.864 505.203 363.235C514.186 359.605 520.455 370.015 529.333 366.428C538.21 362.841 538.581 349.749 538.581 349.749",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.7 164.621C1231.7 164.621 1240.13 174.161 1249.94 170.194C1259.76 166.228 1256.1 154.765 1265.08 151.135C1274.07 147.506 1280.33 157.915 1289.21 154.329C1298.09 150.742 1298.46 137.649 1298.46 137.649",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.56 490.99C1363.56 490.99 1371.98 500.529 1381.8 496.563C1391.62 492.597 1387.96 481.133 1396.94 477.504C1405.92 473.874 1412.19 484.284 1421.07 480.697C1429.95 477.11 1430.32 464.018 1430.32 464.018",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297.63 327.805C1297.63 327.805 1306.05 337.345 1315.87 333.379C1325.69 329.412 1322.03 317.949 1331.01 314.32C1339.99 310.69 1346.26 321.1 1355.14 317.513C1364.02 313.926 1364.39 300.834 1364.39 300.834",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.43 817.359C1495.43 817.359 1503.85 826.898 1513.67 822.932C1523.48 818.965 1519.82 807.502 1528.8 803.873C1537.79 800.243 1544.06 810.653 1552.93 807.066C1561.81 803.479 1562.18 790.387 1562.18 790.387",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.77 1.43665C1165.77 1.43665 1174.2 10.9763 1184.01 7.00986C1193.83 3.04344 1190.17 -8.41969 1199.15 -12.0492C1208.14 -15.6787 1214.4 -5.26904 1223.28 -8.85583C1232.16 -12.4426 1232.53 -25.535 1232.53 -25.535",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429.5 654.174C1429.5 654.174 1437.92 663.714 1447.74 659.747C1457.55 655.781 1453.89 644.318 1462.87 640.688C1471.86 637.059 1478.13 647.469 1487 643.882C1495.88 640.295 1496.25 627.203 1496.25 627.203",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.67 246.213C1264.67 246.213 1273.09 255.753 1282.91 251.786C1292.72 247.82 1289.06 236.357 1298.05 232.727C1307.03 229.098 1313.3 239.508 1322.18 235.921C1331.05 232.334 1331.43 219.242 1331.43 219.242",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.53 572.582C1396.53 572.582 1404.95 582.122 1414.77 578.155C1424.59 574.189 1420.93 562.726 1429.91 559.096C1438.89 555.467 1445.16 565.876 1454.04 562.289C1462.92 558.703 1463.29 545.61 1463.29 545.61",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.6 409.398C1330.6 409.398 1339.02 418.937 1348.84 414.971C1358.65 411.004 1354.99 399.541 1363.98 395.912C1372.96 392.282 1379.23 402.692 1388.11 399.105C1396.98 395.518 1397.35 382.426 1397.35 382.426",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1528.39 898.951C1528.39 898.951 1536.81 908.49 1546.63 904.524C1556.45 900.557 1552.79 889.094 1561.77 885.465C1570.75 881.835 1577.02 892.245 1585.9 888.658C1594.78 885.071 1595.15 871.979 1595.15 871.979",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.74 83.0289C1198.74 83.0289 1207.16 92.5686 1216.98 88.6021C1226.79 84.6357 1223.13 73.1726 1232.12 69.5431C1241.1 65.9136 1247.37 76.3232 1256.25 72.7365C1265.12 69.1497 1265.5 56.0573 1265.5 56.0573",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462.46 735.766C1462.46 735.766 1470.88 745.306 1480.7 741.34C1490.52 737.373 1486.86 725.91 1495.84 722.28C1504.82 718.651 1511.09 729.061 1519.97 725.474C1528.85 721.887 1529.22 708.795 1529.22 708.795",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.441 511.395C405.441 511.395 404.873 498.682 414.69 494.716C424.508 490.749 429.837 501.538 438.82 497.909C447.803 494.279 445.082 482.437 453.959 478.85C462.837 475.263 472.199 484.423 472.199 484.423",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.578 185.026C273.578 185.026 273.01 172.313 282.827 168.347C292.644 164.38 297.973 175.17 306.957 171.54C315.94 167.911 313.218 156.068 322.096 152.481C330.974 148.894 340.335 158.054 340.335 158.054",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.305 837.763C537.305 837.763 536.736 825.051 546.554 821.084C556.371 817.118 561.7 827.907 570.683 824.278C579.667 820.648 576.945 808.805 585.823 805.219C594.7 801.632 604.062 810.792 604.062 810.792",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.648 21.8417C207.648 21.8417 207.08 9.1289 216.897 5.16248C226.715 1.19605 232.044 11.9853 241.027 8.35584C250.01 4.72634 247.289 -7.11642 256.166 -10.7032C265.044 -14.29 274.406 -5.13 274.406 -5.13",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.371 674.579C471.371 674.579 470.803 661.866 480.62 657.9C490.437 653.933 495.766 664.723 504.75 661.093C513.733 657.464 511.011 645.621 519.889 642.034C528.767 638.447 538.128 647.607 538.128 647.607",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.512 348.21C339.512 348.21 338.943 335.498 348.761 331.531C358.578 327.565 363.907 338.354 372.89 334.725C381.874 331.095 379.152 319.252 388.03 315.666C396.907 312.079 406.269 321.239 406.269 321.239",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.406 592.987C438.406 592.987 437.838 580.274 447.655 576.308C457.472 572.341 462.802 583.131 471.785 579.501C480.768 575.872 478.046 564.029 486.924 560.442C495.802 556.855 505.163 566.015 505.163 566.015",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.547 266.618C306.547 266.618 305.978 253.905 315.796 249.939C325.613 245.973 330.942 256.762 339.925 253.132C348.909 249.503 346.187 237.66 355.065 234.073C363.942 230.486 373.304 239.646 373.304 239.646",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.27 919.356C570.27 919.356 569.701 906.643 579.518 902.676C589.336 898.71 594.665 909.499 603.648 905.87C612.631 902.24 609.91 890.398 618.787 886.811C627.665 883.224 637.027 892.384 637.027 892.384",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.613 103.434C240.613 103.434 240.045 90.7211 249.862 86.7546C259.679 82.7882 265.009 93.5775 273.992 89.948C282.975 86.3185 280.253 74.4757 289.131 70.8889C298.009 67.3021 307.371 76.4622 307.371 76.4622",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.336 756.171C504.336 756.171 503.768 743.459 513.585 739.492C523.402 735.526 528.731 746.315 537.715 742.685C546.698 739.056 543.976 727.213 552.854 723.626C561.731 720.04 571.093 729.2 571.093 729.2",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.477 429.803C372.477 429.803 371.908 417.09 381.725 413.123C391.543 409.157 396.872 419.946 405.855 416.317C414.839 412.687 412.117 400.845 420.994 397.258C429.872 393.671 439.234 402.831 439.234 402.831",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.35 217.703C1132.35 217.703 1131.78 204.99 1141.6 201.024C1151.42 197.058 1156.75 207.847 1165.73 204.217C1174.71 200.588 1171.99 188.745 1180.87 185.158C1189.75 181.572 1199.11 190.732 1199.11 190.732",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.08 870.441C1396.08 870.441 1395.51 857.728 1405.33 853.761C1415.14 849.795 1420.47 860.584 1429.46 856.955C1438.44 853.325 1435.72 841.483 1444.6 837.896C1453.47 834.309 1462.84 843.469 1462.84 843.469",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.42 54.5188C1066.42 54.5188 1065.85 41.806 1075.67 37.8396C1085.49 33.8732 1090.82 44.6625 1099.8 41.033C1108.78 37.4035 1106.06 25.5607 1114.94 21.9739C1123.82 18.3871 1133.18 27.5471 1133.18 27.5471",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.14 707.256C1330.14 707.256 1329.58 694.544 1339.39 690.577C1349.21 686.611 1354.54 697.4 1363.52 693.77C1372.51 690.141 1369.78 678.298 1378.66 674.711C1387.54 671.125 1396.9 680.285 1396.9 680.285",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.32 299.295C1165.32 299.295 1164.75 286.583 1174.57 282.616C1184.39 278.65 1189.72 289.439 1198.7 285.81C1207.68 282.18 1204.96 270.337 1213.84 266.751C1222.72 263.164 1232.08 272.324 1232.08 272.324",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297.18 625.664C1297.18 625.664 1296.61 612.951 1306.43 608.985C1316.25 605.018 1321.57 615.808 1330.56 612.178C1339.54 608.549 1336.82 596.706 1345.7 593.119C1354.58 589.532 1363.94 598.692 1363.94 598.692",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429.04 952.033C1429.04 952.033 1428.47 939.32 1438.29 935.354C1448.11 931.387 1453.44 942.176 1462.42 938.547C1471.4 934.917 1468.68 923.075 1477.56 919.488C1486.44 915.901 1495.8 925.061 1495.8 925.061",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.39 136.111C1099.39 136.111 1098.82 123.398 1108.64 119.432C1118.45 115.465 1123.78 126.255 1132.77 122.625C1141.75 118.996 1139.03 107.153 1147.9 103.566C1156.78 99.9793 1166.14 109.139 1166.14 109.139",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.11 788.848C1363.11 788.848 1362.54 776.136 1372.36 772.169C1382.18 768.203 1387.5 778.992 1396.49 775.363C1405.47 771.733 1402.75 759.89 1411.63 756.304C1420.5 752.717 1429.87 761.877 1429.87 761.877",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.129 427.483C613.129 427.483 612.561 414.77 622.378 410.804C632.195 406.837 637.524 417.627 646.508 413.997C655.491 410.368 652.769 398.525 661.647 394.938C670.524 391.351 679.886 400.511 679.886 400.511",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.27 101.114C481.27 101.114 480.701 88.4014 490.518 84.4349C500.336 80.4685 505.665 91.2578 514.648 87.6283C523.631 83.9988 520.91 72.156 529.787 68.5692C538.665 64.9824 548.027 74.1425 548.027 74.1425",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.992 753.852C744.992 753.852 744.424 741.139 754.241 737.172C764.058 733.206 769.387 743.995 778.371 740.366C787.354 736.736 784.632 724.894 793.51 721.307C802.388 717.72 811.749 726.88 811.749 726.88",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.062 590.667C679.062 590.667 678.494 577.954 688.311 573.988C698.129 570.022 703.458 580.811 712.441 577.181C721.424 573.552 718.703 561.709 727.58 558.122C736.458 554.536 745.82 563.696 745.82 563.696",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.199 264.298C547.199 264.298 546.631 251.586 556.448 247.619C566.265 243.653 571.595 254.442 580.578 250.813C589.561 247.183 586.839 235.34 595.717 231.754C604.595 228.167 613.956 237.327 613.956 237.327",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.922 917.036C810.922 917.036 810.353 904.323 820.171 900.357C829.988 896.39 835.317 907.18 844.3 903.55C853.284 899.921 850.562 888.078 859.44 884.491C868.317 880.904 877.679 890.064 877.679 890.064",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.098 509.075C646.098 509.075 645.529 496.362 655.347 492.396C665.164 488.429 670.493 499.219 679.476 495.589C688.46 491.96 685.738 480.117 694.615 476.53C703.493 472.943 712.855 482.103 712.855 482.103",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.234 182.706C514.234 182.706 513.666 169.994 523.483 166.027C533.3 162.061 538.63 172.85 547.613 169.22C556.596 165.591 553.875 153.748 562.752 150.161C571.63 146.575 580.992 155.735 580.992 155.735",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.957 835.444C777.957 835.444 777.389 822.731 787.206 818.765C797.023 814.798 802.352 825.587 811.336 821.958C820.319 818.328 817.597 806.486 826.475 802.899C835.352 799.312 844.714 808.472 844.714 808.472",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.305 19.522C448.305 19.522 447.736 6.8092 457.554 2.84277C467.371 -1.12365 472.7 9.66563 481.683 6.03613C490.667 2.40663 487.945 -9.43612 496.823 -13.0229C505.7 -16.6097 515.062 -7.4497 515.062 -7.4497",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.027 672.259C712.027 672.259 711.459 659.547 721.276 655.58C731.093 651.614 736.423 662.403 745.406 658.774C754.389 655.144 751.668 643.301 760.545 639.715C769.423 636.128 778.785 645.288 778.785 645.288",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.164 345.891C580.164 345.891 579.596 333.178 589.413 329.212C599.23 325.245 604.559 336.034 613.543 332.405C622.526 328.775 619.804 316.933 628.682 313.346C637.56 309.759 646.921 318.919 646.921 318.919",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.04 133.791C1340.04 133.791 1339.47 121.079 1349.29 117.112C1359.11 113.146 1364.44 123.935 1373.42 120.306C1382.4 116.676 1379.68 104.833 1388.56 101.246C1397.44 97.6597 1406.8 106.82 1406.8 106.82",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471.9 460.16C1471.9 460.16 1471.33 447.447 1481.15 443.481C1490.97 439.514 1496.3 450.304 1505.28 446.674C1514.26 443.045 1511.54 431.202 1520.42 427.615C1529.3 424.028 1538.66 433.188 1538.66 433.188",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1669.7 949.713C1669.7 949.713 1669.13 937 1678.94 933.034C1688.76 929.068 1694.09 939.857 1703.07 936.227C1712.06 932.598 1709.34 920.755 1718.21 917.168C1727.09 913.581 1736.45 922.741 1736.45 922.741",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405.97 296.976C1405.97 296.976 1405.4 284.263 1415.22 280.297C1425.04 276.33 1430.37 287.119 1439.35 283.49C1448.33 279.86 1445.61 268.018 1454.49 264.431C1463.37 260.844 1472.73 270.004 1472.73 270.004",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.77 786.529C1603.77 786.529 1603.2 773.816 1613.01 769.85C1622.83 765.883 1628.16 776.672 1637.14 773.043C1646.13 769.413 1643.41 757.571 1652.28 753.984C1661.16 750.397 1670.52 759.557 1670.52 759.557",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.84 623.344C1537.84 623.344 1537.27 610.632 1547.08 606.665C1556.9 602.699 1562.23 613.488 1571.21 609.859C1580.2 606.229 1577.48 594.386 1586.35 590.799C1595.23 587.213 1604.59 596.373 1604.59 596.373",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.01 215.384C1373.01 215.384 1372.44 202.671 1382.26 198.704C1392.07 194.738 1397.4 205.527 1406.39 201.898C1415.37 198.268 1412.65 186.425 1421.53 182.839C1430.4 179.252 1439.77 188.412 1439.77 188.412",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.87 541.752C1504.87 541.752 1504.3 529.039 1514.12 525.073C1523.94 521.107 1529.27 531.896 1538.25 528.266C1547.23 524.637 1544.51 512.794 1553.39 509.207C1562.27 505.621 1571.63 514.781 1571.63 514.781",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1438.94 378.568C1438.94 378.568 1438.37 365.855 1448.19 361.889C1458 357.922 1463.33 368.712 1472.32 365.082C1481.3 361.453 1478.58 349.61 1487.46 346.023C1496.33 342.436 1505.69 351.596 1505.69 351.596",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1636.73 868.121C1636.73 868.121 1636.16 855.408 1645.98 851.442C1655.8 847.475 1661.13 858.265 1670.11 854.635C1679.09 851.006 1676.37 839.163 1685.25 835.576C1694.13 831.989 1703.49 841.149 1703.49 841.149",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.08 52.1991C1307.08 52.1991 1306.51 39.4863 1316.33 35.5199C1326.14 31.5535 1331.47 42.3428 1340.46 38.7133C1349.44 35.0838 1346.72 23.241 1355.6 19.6542C1364.47 16.0674 1373.84 25.2274 1373.84 25.2274",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570.8 704.937C1570.8 704.937 1570.23 692.224 1580.05 688.257C1589.87 684.291 1595.2 695.08 1604.18 691.451C1613.16 687.821 1610.44 675.978 1619.32 672.392C1628.2 668.805 1637.56 677.965 1637.56 677.965",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.24 38.7533C1543.24 38.7533 1551.66 48.2929 1561.48 44.3265C1571.29 40.3601 1567.63 28.897 1576.62 25.2675C1585.6 21.638 1591.87 32.0476 1600.75 28.4608C1609.62 24.874 1610 11.7816 1610 11.7816",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.1 365.122C1675.1 365.122 1683.52 374.662 1693.34 370.695C1703.15 366.729 1699.49 355.266 1708.48 351.636C1717.46 348.007 1723.73 358.416 1732.61 354.829C1741.48 351.243 1741.85 338.15 1741.85 338.15",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1872.89 854.675C1872.89 854.675 1881.31 864.215 1891.13 860.248C1900.95 856.282 1897.29 844.819 1906.27 841.189C1915.25 837.56 1921.52 847.969 1930.4 844.383C1939.28 840.796 1939.65 827.703 1939.65 827.703",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1609.17 201.938C1609.17 201.938 1617.59 211.477 1627.41 207.511C1637.22 203.544 1633.56 192.081 1642.55 188.452C1651.53 184.822 1657.8 195.232 1666.68 191.645C1675.55 188.058 1675.93 174.966 1675.93 174.966",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806.96 691.491C1806.96 691.491 1815.38 701.03 1825.2 697.064C1835.02 693.097 1831.36 681.634 1840.34 678.005C1849.32 674.375 1855.59 684.785 1864.47 681.198C1873.35 677.611 1873.72 664.519 1873.72 664.519",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1741.03 528.306C1741.03 528.306 1749.45 537.846 1759.27 533.879C1769.08 529.913 1765.42 518.45 1774.41 514.82C1783.39 511.191 1789.66 521.601 1798.54 518.014C1807.41 514.427 1807.78 501.335 1807.78 501.335",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1576.2 120.345C1576.2 120.345 1584.63 129.885 1594.44 125.919C1604.26 121.952 1600.6 110.489 1609.58 106.86C1618.57 103.23 1624.83 113.64 1633.71 110.053C1642.59 106.466 1642.96 93.3738 1642.96 93.3738",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1708.06 446.714C1708.06 446.714 1716.48 456.254 1726.3 452.287C1736.12 448.321 1732.46 436.858 1741.44 433.228C1750.42 429.599 1756.69 440.008 1765.57 436.422C1774.45 432.835 1774.82 419.742 1774.82 419.742",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1905.86 936.267C1905.86 936.267 1914.28 945.807 1924.09 941.84C1933.91 937.874 1930.25 926.411 1939.23 922.781C1948.22 919.152 1954.49 929.562 1963.36 925.975C1972.24 922.388 1972.61 909.296 1972.61 909.296",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642.13 283.53C1642.13 283.53 1650.55 293.069 1660.37 289.103C1670.19 285.137 1666.53 273.673 1675.51 270.044C1684.49 266.414 1690.76 276.824 1699.64 273.237C1708.52 269.651 1708.89 256.558 1708.89 256.558",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1839.93 773.083C1839.93 773.083 1848.35 782.623 1858.17 778.656C1867.98 774.69 1864.32 763.227 1873.3 759.597C1882.29 755.968 1888.56 766.377 1897.43 762.79C1906.31 759.204 1906.68 746.111 1906.68 746.111",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774 609.899C1774 609.899 1782.42 619.438 1792.24 615.472C1802.05 611.505 1798.39 600.042 1807.37 596.413C1816.36 592.783 1822.63 603.193 1831.5 599.606C1840.38 596.019 1840.75 582.927 1840.75 582.927",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.89 91.8353C1443.89 91.8353 1443.32 79.1226 1453.14 75.1561C1462.95 71.1897 1468.28 81.979 1477.27 78.3495C1486.25 74.72 1483.53 62.8772 1492.4 59.2904C1501.28 55.7036 1510.64 64.8636 1510.64 64.8636",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1575.75 418.204C1575.75 418.204 1575.18 405.491 1585 401.525C1594.82 397.558 1600.15 408.348 1609.13 404.718C1618.11 401.089 1615.39 389.246 1624.27 385.659C1633.15 382.072 1642.51 391.232 1642.51 391.232",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.54 907.757C1773.54 907.757 1772.97 895.044 1782.79 891.078C1792.61 887.112 1797.93 897.901 1806.92 894.271C1815.9 890.642 1813.18 878.799 1822.06 875.212C1830.93 871.626 1840.3 880.786 1840.3 880.786",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509.82 255.02C1509.82 255.02 1509.25 242.307 1519.07 238.341C1528.88 234.374 1534.21 245.163 1543.2 241.534C1552.18 237.904 1549.46 226.062 1558.33 222.475C1567.21 218.888 1576.57 228.048 1576.57 228.048",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.61 744.573C1707.61 744.573 1707.04 731.86 1716.86 727.894C1726.68 723.927 1732 734.716 1740.99 731.087C1749.97 727.457 1747.25 715.615 1756.13 712.028C1765 708.441 1774.37 717.601 1774.37 717.601",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1641.68 581.388C1641.68 581.388 1641.11 568.676 1650.93 564.709C1660.75 560.743 1666.07 571.532 1675.06 567.903C1684.04 564.273 1681.32 552.43 1690.2 548.844C1699.08 545.257 1708.44 554.417 1708.44 554.417",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.85 173.428C1476.85 173.428 1476.28 160.715 1486.1 156.748C1495.92 152.782 1501.25 163.571 1510.23 159.942C1519.21 156.312 1516.49 144.47 1525.37 140.883C1534.25 137.296 1543.61 146.456 1543.61 146.456",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1608.71 499.796C1608.71 499.796 1608.15 487.083 1617.96 483.117C1627.78 479.151 1633.11 489.94 1642.09 486.31C1651.08 482.681 1648.36 470.838 1657.23 467.251C1666.11 463.665 1675.47 472.825 1675.47 472.825",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542.79 336.612C1542.79 336.612 1542.22 323.899 1552.03 319.933C1561.85 315.966 1567.18 326.756 1576.16 323.126C1585.15 319.497 1582.43 307.654 1591.3 304.067C1600.18 300.48 1609.54 309.64 1609.54 309.64",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740.57 826.165C1740.57 826.165 1740.01 813.452 1749.82 809.486C1759.64 805.519 1764.97 816.309 1773.95 812.679C1782.94 809.05 1780.21 797.207 1789.09 793.62C1797.97 790.033 1807.33 799.193 1807.33 799.193",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410.92 10.2432C1410.92 10.2432 1410.35 -2.46961 1420.17 -6.43603C1429.99 -10.4025 1435.32 0.386824 1444.3 -3.24267C1453.28 -6.87217 1450.56 -18.7149 1459.44 -22.3017C1468.32 -25.8885 1477.68 -16.7285 1477.68 -16.7285",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.64 662.981C1674.64 662.981 1674.08 650.268 1683.89 646.301C1693.71 642.335 1699.04 653.124 1708.02 649.495C1717.01 645.865 1714.28 634.022 1723.16 630.436C1732.04 626.849 1741.4 636.009 1741.4 636.009",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651.58 7.92346C1651.58 7.92346 1651.01 -4.78931 1660.83 -8.75574C1670.64 -12.7222 1675.97 -1.93288 1684.96 -5.56238C1693.94 -9.19188 1691.22 -21.0346 1700.1 -24.6214C1708.97 -28.2082 1718.34 -19.0482 1718.34 -19.0482",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1783.44 334.292C1783.44 334.292 1782.87 321.579 1792.69 317.613C1802.5 313.647 1807.83 324.436 1816.82 320.806C1825.8 317.177 1823.08 305.334 1831.96 301.747C1840.83 298.161 1850.19 307.321 1850.19 307.321",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1981.23 823.845C1981.23 823.845 1980.66 811.133 1990.48 807.166C2000.3 803.2 2005.63 813.989 2014.61 810.359C2023.59 806.73 2020.87 794.887 2029.75 791.3C2038.63 787.714 2047.99 796.874 2047.99 796.874",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1717.51 171.108C1717.51 171.108 1716.94 158.395 1726.76 154.429C1736.57 150.462 1741.9 161.252 1750.89 157.622C1759.87 153.993 1757.15 142.15 1766.03 138.563C1774.9 134.976 1784.27 144.136 1784.27 144.136",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1915.3 660.661C1915.3 660.661 1914.73 647.948 1924.55 643.982C1934.37 640.015 1939.7 650.805 1948.68 647.175C1957.66 643.546 1954.94 631.703 1963.82 628.116C1972.7 624.529 1982.06 633.689 1982.06 633.689",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1849.37 497.477C1849.37 497.477 1848.8 484.764 1858.62 480.797C1868.43 476.831 1873.76 487.62 1882.75 483.991C1891.73 480.361 1889.01 468.518 1897.89 464.932C1906.76 461.345 1916.12 470.505 1916.12 470.505",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2047.16 987.03C2047.16 987.03 2046.59 974.317 2056.41 970.35C2066.23 966.384 2071.56 977.173 2080.54 973.544C2089.52 969.914 2086.8 958.072 2095.68 954.485C2104.56 950.898 2113.92 960.058 2113.92 960.058",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.54 89.5157C1684.54 89.5157 1683.97 76.803 1693.79 72.8365C1703.61 68.8701 1708.94 79.6594 1717.92 76.0299C1726.9 72.4004 1724.18 60.5577 1733.06 56.9709C1741.94 53.3841 1751.3 62.5441 1751.3 62.5441",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1816.4 415.884C1816.4 415.884 1815.83 403.172 1825.65 399.205C1835.47 395.239 1840.8 406.028 1849.78 402.399C1858.76 398.769 1856.04 386.926 1864.92 383.34C1873.8 379.753 1883.16 388.913 1883.16 388.913",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2014.2 905.438C2014.2 905.438 2013.63 892.725 2023.44 888.758C2033.26 884.792 2038.59 895.581 2047.57 891.952C2056.56 888.322 2053.84 876.479 2062.71 872.893C2071.59 869.306 2080.95 878.466 2080.95 878.466",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750.47 252.7C1750.47 252.7 1749.9 239.987 1759.72 236.021C1769.54 232.054 1774.87 242.844 1783.85 239.214C1792.83 235.585 1790.11 223.742 1798.99 220.155C1807.87 216.568 1817.23 225.728 1817.23 225.728",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1948.27 742.253C1948.27 742.253 1947.7 729.54 1957.51 725.574C1967.33 721.607 1972.66 732.397 1981.64 728.767C1990.63 725.138 1987.91 713.295 1996.78 709.708C2005.66 706.121 2015.02 715.281 2015.02 715.281",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1882.34 579.069C1882.34 579.069 1881.77 566.356 1891.58 562.39C1901.4 558.423 1906.73 569.212 1915.71 565.583C1924.7 561.953 1921.98 550.111 1930.85 546.524C1939.73 542.937 1949.09 552.097 1949.09 552.097",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1986.63 239.254C1986.63 239.254 1995.05 248.794 2004.87 244.827C2014.69 240.861 2011.03 229.398 2020.01 225.768C2028.99 222.139 2035.26 232.548 2044.14 228.962C2053.02 225.375 2053.39 212.282 2053.39 212.282",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2184.43 728.807C2184.43 728.807 2192.85 738.347 2202.67 734.38C2212.48 730.414 2208.82 718.951 2217.8 715.321C2226.79 711.692 2233.06 722.102 2241.93 718.515C2250.81 714.928 2251.18 701.836 2251.18 701.836",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920.7 76.0698C1920.7 76.0698 1929.12 85.6095 1938.94 81.643C1948.76 77.6766 1945.09 66.2135 1954.08 62.584C1963.06 58.9545 1969.33 69.3641 1978.21 65.7773C1987.09 62.1905 1987.46 49.0981 1987.46 49.0981",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2118.49 565.623C2118.49 565.623 2126.91 575.163 2136.73 571.196C2146.55 567.23 2142.89 555.767 2151.87 552.137C2160.85 548.508 2167.12 558.917 2176 555.33C2184.88 551.744 2185.25 538.651 2185.25 538.651",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2052.56 402.438C2052.56 402.438 2060.98 411.978 2070.8 408.012C2080.62 404.045 2076.96 392.582 2085.94 388.953C2094.92 385.323 2101.19 395.733 2110.07 392.146C2118.95 388.559 2119.32 375.467 2119.32 375.467",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2250.36 891.992C2250.36 891.992 2258.78 901.531 2268.59 897.565C2278.41 893.598 2274.75 882.135 2283.73 878.506C2292.72 874.876 2298.99 885.286 2307.86 881.699C2316.74 878.112 2317.11 865.02 2317.11 865.02",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1887.73 -5.52234C1887.73 -5.52234 1896.16 4.0173 1905.97 0.0508754C1915.79 -3.91555 1912.13 -15.3787 1921.11 -19.0082C1930.1 -22.6377 1936.37 -12.228 1945.24 -15.8148C1954.12 -19.4016 1954.49 -32.494 1954.49 -32.494",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2019.6 320.846C2019.6 320.846 2028.02 330.386 2037.84 326.42C2047.65 322.453 2043.99 310.99 2052.98 307.36C2061.96 303.731 2068.23 314.141 2077.11 310.554C2085.98 306.967 2086.35 293.875 2086.35 293.875",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2217.39 810.399C2217.39 810.399 2225.81 819.939 2235.63 815.973C2245.45 812.006 2241.79 800.543 2250.77 796.914C2259.75 793.284 2266.02 803.694 2274.9 800.107C2283.78 796.52 2284.15 783.428 2284.15 783.428",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953.67 157.662C1953.67 157.662 1962.09 167.202 1971.91 163.235C1981.72 159.269 1978.06 147.806 1987.05 144.176C1996.03 140.547 2002.3 150.956 2011.18 147.37C2020.05 143.783 2020.43 130.69 2020.43 130.69",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2151.46 647.215C2151.46 647.215 2159.88 656.755 2169.7 652.788C2179.51 648.822 2175.85 637.359 2184.84 633.729C2193.82 630.1 2200.09 640.509 2208.97 636.923C2217.84 633.336 2218.21 620.243 2218.21 620.243",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2085.53 484.031C2085.53 484.031 2093.95 493.57 2103.77 489.604C2113.58 485.637 2109.92 474.174 2118.91 470.545C2127.89 466.915 2134.16 477.325 2143.04 473.738C2151.91 470.151 2152.28 457.059 2152.28 457.059",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2283.32 973.584C2283.32 973.584 2291.74 983.123 2301.56 979.157C2311.38 975.191 2307.72 963.727 2316.7 960.098C2325.68 956.468 2331.95 966.878 2340.83 963.291C2349.71 959.705 2350.08 946.612 2350.08 946.612",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1887.28 292.336C1887.28 292.336 1886.71 279.624 1896.53 275.657C1906.35 271.691 1911.68 282.48 1920.66 278.85C1929.64 275.221 1926.92 263.378 1935.8 259.791C1944.68 256.205 1954.04 265.365 1954.04 265.365",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2085.07 781.889C2085.07 781.889 2084.51 769.177 2094.32 765.21C2104.14 761.244 2109.47 772.033 2118.45 768.404C2127.44 764.774 2124.71 752.931 2133.59 749.345C2142.47 745.758 2151.83 754.918 2151.83 754.918",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1821.35 129.152C1821.35 129.152 1820.78 116.439 1830.6 112.473C1840.42 108.506 1845.75 119.296 1854.73 115.666C1863.71 112.037 1860.99 100.194 1869.87 96.6071C1878.75 93.0203 1888.11 102.18 1888.11 102.18",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2019.14 618.705C2019.14 618.705 2018.58 605.992 2028.39 602.026C2038.21 598.059 2043.54 608.849 2052.52 605.219C2061.51 601.59 2058.78 589.747 2067.66 586.16C2076.54 582.573 2085.9 591.733 2085.9 591.733",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953.21 455.521C1953.21 455.521 1952.65 442.808 1962.46 438.841C1972.28 434.875 1977.61 445.664 1986.59 442.035C1995.58 438.405 1992.86 426.563 2001.73 422.976C2010.61 419.389 2019.97 428.549 2019.97 428.549",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2151 945.074C2151 945.074 2150.44 932.361 2160.25 928.395C2170.07 924.428 2175.4 935.217 2184.38 931.588C2193.37 927.958 2190.64 916.116 2199.52 912.529C2208.4 908.942 2217.76 918.102 2217.76 918.102",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1788.39 47.5598C1788.39 47.5598 1787.82 34.847 1797.64 30.8806C1807.45 26.9142 1812.78 37.7035 1821.77 34.074C1830.75 30.4445 1828.03 18.6017 1836.9 15.0149C1845.78 11.4281 1855.14 20.5881 1855.14 20.5881",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920.25 373.928C1920.25 373.928 1919.68 361.216 1929.49 357.249C1939.31 353.283 1944.64 364.072 1953.62 360.443C1962.61 356.813 1959.89 344.97 1968.76 341.384C1977.64 337.797 1987 346.957 1987 346.957",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2118.04 863.482C2118.04 863.482 2117.47 850.769 2127.29 846.802C2137.11 842.836 2142.43 853.625 2151.42 849.996C2160.4 846.366 2157.68 834.523 2166.56 830.937C2175.43 827.35 2184.8 836.51 2184.8 836.51",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1854.32 210.744C1854.32 210.744 1853.75 198.031 1863.57 194.065C1873.38 190.099 1878.71 200.888 1887.7 197.258C1896.68 193.629 1893.96 181.786 1902.83 178.199C1911.71 174.612 1921.07 183.772 1921.07 183.772",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2052.11 700.297C2052.11 700.297 2051.54 687.584 2061.36 683.618C2071.18 679.652 2076.5 690.441 2085.49 686.811C2094.47 683.182 2091.75 671.339 2100.63 667.752C2109.5 664.165 2118.87 673.326 2118.87 673.326",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1986.18 537.113C1986.18 537.113 1985.61 524.4 1995.43 520.434C2005.25 516.467 2010.57 527.256 2019.56 523.627C2028.54 519.997 2025.82 508.155 2034.7 504.568C2043.58 500.981 2052.94 510.141 2052.94 510.141",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2094.97 208.424C2094.97 208.424 2094.4 195.712 2104.22 191.745C2114.04 187.779 2119.37 198.568 2128.35 194.939C2137.33 191.309 2134.61 179.466 2143.49 175.88C2152.37 172.293 2161.73 181.453 2161.73 181.453",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2292.77 697.977C2292.77 697.977 2292.2 685.265 2302.01 681.298C2311.83 677.332 2317.16 688.121 2326.14 684.492C2335.13 680.862 2332.41 669.019 2341.28 665.433C2350.16 661.846 2359.52 671.006 2359.52 671.006",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2029.04 45.2401C2029.04 45.2401 2028.47 32.5273 2038.29 28.5609C2048.11 24.5945 2053.43 35.3838 2062.42 31.7543C2071.4 28.1248 2068.68 16.282 2077.56 12.6952C2086.43 9.10843 2095.8 18.2684 2095.8 18.2684",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2226.83 534.793C2226.83 534.793 2226.26 522.08 2236.08 518.114C2245.9 514.147 2251.23 524.937 2260.21 521.307C2269.19 517.678 2266.47 505.835 2275.35 502.248C2284.23 498.661 2293.59 507.821 2293.59 507.821",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2160.9 371.609C2160.9 371.609 2160.33 358.896 2170.15 354.93C2179.97 350.963 2185.3 361.752 2194.28 358.123C2203.26 354.493 2200.54 342.651 2209.42 339.064C2218.3 335.477 2227.66 344.637 2227.66 344.637",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2358.7 861.162C2358.7 861.162 2358.13 848.449 2367.94 844.483C2377.76 840.516 2383.09 851.306 2392.07 847.676C2401.06 844.047 2398.34 832.204 2407.21 828.617C2416.09 825.03 2425.45 834.19 2425.45 834.19",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2127.94 290.017C2127.94 290.017 2127.37 277.304 2137.19 273.337C2147 269.371 2152.33 280.16 2161.32 276.531C2170.3 272.901 2167.58 261.059 2176.46 257.472C2185.33 253.885 2194.69 263.045 2194.69 263.045",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2325.73 779.57C2325.73 779.57 2325.16 766.857 2334.98 762.891C2344.8 758.924 2350.13 769.713 2359.11 766.084C2368.09 762.454 2365.37 750.612 2374.25 747.025C2383.13 743.438 2392.49 752.598 2392.49 752.598",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2062.01 126.832C2062.01 126.832 2061.44 114.119 2071.26 110.153C2081.07 106.187 2086.4 116.976 2095.39 113.346C2104.37 109.717 2101.65 97.8742 2110.53 94.2874C2119.4 90.7006 2128.77 99.8606 2128.77 99.8606",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2259.8 616.385C2259.8 616.385 2259.23 603.673 2269.05 599.706C2278.86 595.74 2284.19 606.529 2293.18 602.9C2302.16 599.27 2299.44 587.427 2308.31 583.84C2317.19 580.254 2326.55 589.414 2326.55 589.414",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2193.87 453.201C2193.87 453.201 2193.3 440.488 2203.12 436.522C2212.93 432.555 2218.26 443.345 2227.25 439.715C2236.23 436.086 2233.51 424.243 2242.39 420.656C2251.26 417.069 2260.62 426.229 2260.62 426.229",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2391.66 942.754C2391.66 942.754 2391.09 930.041 2400.91 926.075C2410.73 922.108 2416.06 932.898 2425.04 929.268C2434.02 925.639 2431.3 913.796 2440.18 910.209C2449.06 906.622 2458.42 915.782 2458.42 915.782",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2298.16 113.386C2298.16 113.386 2306.59 122.926 2316.4 118.96C2326.22 114.993 2322.56 103.53 2331.54 99.9005C2340.53 96.271 2346.79 106.681 2355.67 103.094C2364.55 99.5071 2364.92 86.4147 2364.92 86.4147",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2495.96 602.939C2495.96 602.939 2504.38 612.479 2514.2 608.513C2524.01 604.546 2520.35 593.083 2529.34 589.454C2538.32 585.824 2544.59 596.234 2553.47 592.647C2562.34 589.06 2562.71 575.968 2562.71 575.968",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2430.03 439.755C2430.03 439.755 2438.45 449.295 2448.27 445.328C2458.08 441.362 2454.42 429.899 2463.41 426.269C2472.39 422.64 2478.66 433.049 2487.54 429.463C2496.41 425.876 2496.78 412.783 2496.78 412.783",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2364.1 276.571C2364.1 276.571 2372.52 286.11 2382.34 282.144C2392.15 278.177 2388.49 266.714 2397.48 263.085C2406.46 259.455 2412.73 269.865 2421.61 266.278C2430.48 262.691 2430.85 249.599 2430.85 249.599",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2331.13 194.979C2331.13 194.979 2339.55 204.518 2349.37 200.552C2359.19 196.585 2355.53 185.122 2364.51 181.493C2373.49 177.863 2379.76 188.273 2388.64 184.686C2397.52 181.099 2397.89 168.007 2397.89 168.007",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2265.2 31.7942C2265.2 31.7942 2273.62 41.3338 2283.44 37.3674C2293.26 33.401 2289.59 21.9378 2298.58 18.3084C2307.56 14.6789 2313.83 25.0885 2322.71 21.5017C2331.59 17.9149 2331.96 4.82251 2331.96 4.82251",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2462.99 521.347C2462.99 521.347 2471.41 530.887 2481.23 526.921C2491.05 522.954 2487.39 511.491 2496.37 507.861C2505.35 504.232 2511.62 514.642 2520.5 511.055C2529.38 507.468 2529.75 494.376 2529.75 494.376",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2397.06 358.163C2397.06 358.163 2405.48 367.702 2415.3 363.736C2425.12 359.77 2421.46 348.307 2430.44 344.677C2439.42 341.048 2445.69 351.457 2454.57 347.87C2463.45 344.284 2463.82 331.191 2463.82 331.191",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2198.82 166.469C2198.82 166.469 2198.25 153.756 2208.07 149.789C2217.88 145.823 2223.21 156.612 2232.2 152.983C2241.18 149.353 2238.46 137.51 2247.33 133.924C2256.21 130.337 2265.57 139.497 2265.57 139.497",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2396.61 656.022C2396.61 656.022 2396.04 643.309 2405.86 639.342C2415.68 635.376 2421 646.165 2429.99 642.536C2438.97 638.906 2436.25 627.064 2445.13 623.477C2454 619.89 2463.37 629.05 2463.37 629.05",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2132.89 3.28418C2132.89 3.28418 2132.32 -9.4286 2142.14 -13.395C2151.95 -17.3614 2157.28 -6.57216 2166.27 -10.2017C2175.25 -13.8312 2172.53 -25.6739 2181.4 -29.2607C2190.28 -32.8475 2199.64 -23.6875 2199.64 -23.6875",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330.68 492.837C2330.68 492.837 2330.11 480.124 2339.93 476.158C2349.75 472.192 2355.07 482.981 2364.06 479.351C2373.04 475.722 2370.32 463.879 2379.2 460.292C2388.08 456.705 2397.44 465.865 2397.44 465.865",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2264.75 329.653C2264.75 329.653 2264.18 316.94 2273.99 312.974C2283.81 309.007 2289.14 319.796 2298.12 316.167C2307.11 312.537 2304.39 300.695 2313.26 297.108C2322.14 293.521 2331.5 302.681 2331.5 302.681",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2462.54 819.206C2462.54 819.206 2461.97 806.493 2471.79 802.527C2481.61 798.56 2486.93 809.35 2495.92 805.72C2504.9 802.091 2502.18 790.248 2511.06 786.661C2519.93 783.074 2529.3 792.234 2529.3 792.234",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2231.78 248.061C2231.78 248.061 2231.21 235.348 2241.03 231.381C2250.85 227.415 2256.18 238.204 2265.16 234.575C2274.14 230.945 2271.42 219.103 2280.3 215.516C2289.18 211.929 2298.54 221.089 2298.54 221.089",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2429.57 737.614C2429.57 737.614 2429.01 724.901 2438.82 720.935C2448.64 716.968 2453.97 727.757 2462.95 724.128C2471.94 720.498 2469.21 708.656 2478.09 705.069C2486.97 701.482 2496.33 710.642 2496.33 710.642",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2165.85 84.8763C2165.85 84.8763 2165.28 72.1636 2175.1 68.1971C2184.92 64.2307 2190.25 75.02 2199.23 71.3905C2208.21 67.761 2205.49 55.9182 2214.37 52.3315C2223.25 48.7447 2232.61 57.9047 2232.61 57.9047",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2363.64 574.429C2363.64 574.429 2363.08 561.717 2372.89 557.75C2382.71 553.784 2388.04 564.573 2397.02 560.944C2406.01 557.314 2403.28 545.471 2412.16 541.885C2421.04 538.298 2430.4 547.458 2430.4 547.458",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2297.71 411.245C2297.71 411.245 2297.14 398.532 2306.96 394.566C2316.78 390.599 2322.11 401.389 2331.09 397.759C2340.07 394.13 2337.35 382.287 2346.23 378.7C2355.11 375.113 2364.47 384.273 2364.47 384.273",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2495.5 900.798C2495.5 900.798 2494.94 888.085 2504.75 884.119C2514.57 880.152 2519.9 890.942 2528.88 887.312C2537.87 883.683 2535.14 871.84 2544.02 868.253C2552.9 864.666 2562.26 873.826 2562.26 873.826",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2406.5 82.5566C2406.5 82.5566 2405.94 69.8439 2415.75 65.8774C2425.57 61.911 2430.9 72.7003 2439.88 69.0708C2448.87 65.4413 2446.14 53.5985 2455.02 50.0117C2463.9 46.425 2473.26 55.585 2473.26 55.585",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2472.44 245.741C2472.44 245.741 2471.87 233.028 2481.69 229.062C2491.5 225.095 2496.83 235.885 2505.82 232.255C2514.8 228.626 2512.08 216.783 2520.96 213.196C2529.83 209.609 2539.19 218.769 2539.19 218.769",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2439.47 164.149C2439.47 164.149 2438.9 151.436 2448.72 147.47C2458.54 143.503 2463.87 154.292 2472.85 150.663C2481.83 147.033 2479.11 135.191 2487.99 131.604C2496.87 128.017 2506.23 137.177 2506.23 137.177",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2373.54 0.964478C2373.54 0.964478 2372.97 -11.7483 2382.79 -15.7147C2392.61 -19.6811 2397.93 -8.89186 2406.92 -12.5214C2415.9 -16.1509 2413.18 -27.9936 2422.06 -31.5804C2430.93 -35.1672 2440.3 -26.0072 2440.3 -26.0072",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1248.75 411.395C1248.72 408.041 1250.2 408.041 1250.2 408.041C1250.2 408.041 1251.55 408.14 1252.61 410.791C1260.28 433.396 1264.67 446.31 1272.38 469.048C1272.95 470.645 1271.53 471.616 1271.07 471.728C1266.75 472.778 1263.84 476.498 1262.87 479.223C1260.61 483.468 1259.63 492.052 1261.02 498.751C1261.16 499.419 1259.57 501.692 1258.72 501.692H1235.75C1234.96 501.692 1233.58 500.022 1233.68 499.191C1235 488.364 1235.94 478.232 1224.05 471.742C1223.57 471.481 1222.33 469.709 1222.89 468.222C1230.32 446.313 1234.78 433.166 1242.42 410.625C1243.47 407.604 1245.19 408.019 1245.19 408.019C1245.19 408.019 1246.48 408.271 1246.34 411.395L1246.38 443.485C1246.29 445.87 1246.05 446.96 1244.03 448.062C1241.45 449.463 1240.61 452.421 1241.48 455.216C1242.22 457.616 1244.72 459.498 1247.27 459.574C1250.02 459.656 1252.43 458.023 1253.43 455.395C1254.41 452.832 1253.81 449.748 1251.33 448.365C1248.82 446.961 1248.98 446.84 1248.96 443.601L1248.75 411.395Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.19 485.188C1220.55 485.198 1219.94 485.461 1219.49 485.921C1219.05 486.38 1218.8 486.998 1218.81 487.639C1218.81 498.056 1217.71 507.011 1214.14 513.761C1210.57 520.511 1204.66 525.328 1193.91 527.802C1193.6 527.869 1193.3 527.998 1193.04 528.181C1192.78 528.364 1192.55 528.597 1192.38 528.868C1192.21 529.138 1192.09 529.44 1192.03 529.756C1191.98 530.072 1191.99 530.396 1192.06 530.708C1192.13 531.021 1192.27 531.316 1192.46 531.576C1192.64 531.836 1192.88 532.057 1193.15 532.224C1193.43 532.392 1193.73 532.504 1194.05 532.553C1194.37 532.603 1194.69 532.588 1195 532.512C1206.76 529.805 1214.24 523.941 1218.43 516.018C1222.62 508.094 1223.65 498.38 1223.65 487.639C1223.66 487.316 1223.6 486.995 1223.47 486.695C1223.35 486.396 1223.17 486.123 1222.94 485.895C1222.71 485.666 1222.44 485.486 1222.14 485.365C1221.84 485.243 1221.52 485.183 1221.19 485.188V485.188Z",
    fill: "#94D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.14 507.481C1238.5 507.491 1237.89 507.754 1237.44 508.214C1237 508.673 1236.75 509.291 1236.76 509.932C1236.76 521.75 1230.5 529.873 1218.28 533.249C1217.97 533.332 1217.68 533.475 1217.43 533.67C1217.18 533.864 1216.97 534.107 1216.81 534.384C1216.65 534.661 1216.55 534.966 1216.51 535.283C1216.47 535.599 1216.49 535.92 1216.58 536.228C1216.66 536.535 1216.81 536.823 1217 537.074C1217.2 537.325 1217.45 537.534 1217.72 537.69C1218 537.847 1218.31 537.946 1218.63 537.983C1218.94 538.021 1219.26 537.995 1219.57 537.908C1233.42 534.083 1241.6 523.574 1241.6 509.932C1241.6 509.609 1241.54 509.288 1241.42 508.988C1241.3 508.689 1241.12 508.416 1240.89 508.188C1240.66 507.959 1240.39 507.779 1240.09 507.658C1239.79 507.536 1239.47 507.476 1239.14 507.481V507.481Z",
    fill: "#94D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.01 485.188C1274.65 485.197 1275.26 485.461 1275.71 485.921C1276.16 486.38 1276.4 486.998 1276.39 487.639C1276.39 498.056 1277.49 507.01 1281.06 513.761C1284.63 520.511 1290.54 525.327 1301.29 527.802C1301.6 527.869 1301.9 527.998 1302.16 528.181C1302.43 528.364 1302.65 528.597 1302.82 528.868C1303 529.138 1303.11 529.44 1303.17 529.756C1303.22 530.072 1303.21 530.396 1303.14 530.708C1303.07 531.02 1302.94 531.315 1302.75 531.576C1302.56 531.836 1302.32 532.056 1302.05 532.224C1301.78 532.392 1301.47 532.504 1301.15 532.553C1300.84 532.602 1300.51 532.588 1300.2 532.511C1288.44 529.805 1280.97 523.941 1276.78 516.017C1272.59 508.094 1271.55 498.38 1271.55 487.639C1271.55 487.315 1271.61 486.994 1271.73 486.695C1271.85 486.395 1272.03 486.123 1272.26 485.895C1272.49 485.666 1272.76 485.486 1273.06 485.364C1273.36 485.243 1273.69 485.183 1274.01 485.188V485.188Z",
    fill: "#94D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.06 507.481C1256.7 507.491 1257.31 507.754 1257.76 508.214C1258.21 508.673 1258.45 509.291 1258.44 509.932C1258.44 521.749 1264.7 529.873 1276.92 533.249C1277.23 533.332 1277.52 533.474 1277.77 533.669C1278.03 533.864 1278.24 534.107 1278.4 534.384C1278.55 534.661 1278.66 534.966 1278.7 535.283C1278.74 535.599 1278.71 535.92 1278.63 536.227C1278.54 536.535 1278.4 536.822 1278.2 537.073C1278 537.324 1277.76 537.534 1277.48 537.69C1277.2 537.846 1276.89 537.946 1276.58 537.983C1276.26 538.02 1275.94 537.995 1275.63 537.907C1261.78 534.082 1253.6 523.573 1253.6 509.932C1253.6 509.608 1253.66 509.287 1253.78 508.988C1253.9 508.688 1254.08 508.416 1254.31 508.188C1254.54 507.959 1254.81 507.779 1255.11 507.658C1255.41 507.536 1255.74 507.476 1256.06 507.481V507.481Z",
    fill: "#94D9E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2495,
    height: 947,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquidbigbanner);
export default __webpack_public_path__ + "static/media/squidbigbanner.3fc298ce011c75caee34d3e833030e83.svg";
export { ForwardRef as ReactComponent };